import React, { Suspense } from 'react';
import Tile from './tile';
import { TechSure, DataHelp, EquipmentLearnMore, CustomTvLearnMore, ListingLearnMore, BatteryLearnMore, DigitalAdapterLearnMore, SeeDetailsOverlay, ConnectedAppsTVConnectionsOverlay, ConnectedAppsTVConnectionsOverlayQAM, ConnectedAppsCEAppsOverlay, ConnectedAppsCEAppsOverlayQAM, InternationalCallingOVerlay, InternationalPlanOverlay } from './helperContent';
import ModalOverlay from './../../components/modalOverlay';
import { Service, ModalWindow, OfferTypes } from './../../constants/actionType'
import ChannelLineupMaster from '../../components/channelLineupMaster';
import Button from './../../components/button';
import { openModalWindow, closeModalWindow } from './../../action/modalWindow';
import { InHomeUtils } from './../../util/inhomeUtils';
import ReactHtmlParser from 'react-html-parser';
import { viewDetails, seeFcpDetails, getServiceType, SuppSplOfferPYP, updateIntlCallingPlan } from './../../action/buildProduct';
import { updateSCTags, updateSCcustomEvent, tempSCData } from '../../service/dtmTag';
import { vzdlErrorUpdate, updateVzdlSCCustomEvent, tempVzdlSCData, dataTrack } from '../../service/vzdl';
import { ModalTitle, ModalBody } from '@vds/modals';
import { Title } from '@vds/typography';
import AddlIntrPackages from '../buildProduct/addlIntrPackages';
import { Notification } from '@vds/notifications';
import AutoComplete from "react-autocomplete";
import Email from '../../components/email';
import PhoneNumber from '../../components/phoneNumber';
import { onMobileInputChangeEmerg, onEmailInputChangeEmerg } from './../../../src/action/change/common';
import { formatProduct, formatTVProduct, formatPerks } from "../midnight/services/dataFormatter";
import PerkTile from "../midnight/perks/perkTile";
import { withMobileView } from '../../hooks/useMobileView';
import { RadioButtonGroup } from '@vds/radio-buttons';
import constants from "../midnight/perks/constants";
import MnCarousel from '../midnight/mnCarousel';
const LazyImage = React.lazy(()=>import ('../../components/lazyImage'));
const images = {
  bhrxImage: require("./../../assets/ak-cached/24h/img/accV2/bhrxImage.png")
    .default,
  accRouterImage:
    require("./../../assets/ak-cached/24h/img/accV2/acc_router.png").default,
  voiceRemoteImage:
    require("./../../assets/ak-cached/24h/img/accV2/voice-remote.png").default,
  voiceRemoteImageQAM:
    require("./../../assets/ak-cached/24h/img/accV2/voiceRemoteQAM.png")
      .default,
  accBoxImage: require("./../../assets/ak-cached/24h/img/accV2/acc_box.png")
    .default,
  accBoxImageQAM:
    require("./../../assets/ak-cached/24h/img/accV2/acc_boxQAM.png").default,
  streamingImage:
    require("./../../assets/ak-cached/24h/img/accV2/streaming.png").default,
  premiumChannelImage:
    require("./../../assets/ak-cached/24h/img/accV2/premium-channel-bg.png")
      .default,
};

let specialoffermsg = false;

class productContainer extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: "",
      autocompleteData: [],
      isChanged: false,
      toogleCaContent: true,
      acc: false
    };
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  onClickAccordion = ($event) => {
    this.setState({ ...this.state, acc: !this.state.acc})
  } 

  onChange(e) {
    let value = e.target.value;
    let domesticCountry = value.toLowerCase() === "canada" || value.toLowerCase() === "puerto rico" || value.toLowerCase() === "us virgin islands" || value.toLowerCase() === "guam" || value.toLowerCase() === "american samoa"
    if (domesticCountry) {
      tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
      tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| phone| international calling| same country";
      tempSCData.events = "event15,event20,event46,event5,event21";
      // tempVzdlSCData.events = "event15,event20,event46,event5,event21";
      if (this.props.flowType !== undefined && this.props.flowType === "MV") {
        tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
        updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events")
      } else {
        updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events")
      }

      // tempVzdlSCData.events = "prodView";
      // tempVzdlSCData.detail = "phone international calling same country";
      // updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
      vzdlErrorUpdate('404', 'This location is considered as domestics', 'event11', 'same country error');
    }
    let filteredIntlCallingProducts = this.props.buildProduct.intlCalling.intlCallingProducts.filter(item => (item.countryName).toLowerCase().indexOf(value.toLowerCase()) > -1);
    this.setState({
      value: value,
      isChanged: true,
      autocompleteData: filteredIntlCallingProducts
    });
    this.props.dispatch({ type: Service.intrnlChnlPlan + '_SELECTEDPROD', value: null })
    this.props.dispatch({ type: 'DOMESTIC_COUNTRY_INPUT', value: domesticCountry ? true : false })
  }

  onSelect(val, item) {
    this.setState({
      value: item.countryName,
      isChanged: false
    });
    this.props.dispatch({ type: Service.intrnlChnlPlan + '_SELECTEDPROD', value: item })
    updateSCTags("selected " + item.countryName);
    updateIntlCallingPlan(this.props.visitId, this.props.dispatch, item.pricingPlanCode)
    //  let getintcallingDOM = document.getElementById('intlcalling-autocomplete');
    //  getintcallingDOM.blur();
  }

  handleKeyDown = (e, name) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.props.openModel(e, name);
      e.preventDefault();
    }
  }
  handleKeyDownDetails = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.props.showMoreClick(e);
      e.preventDefault();
    }
  }

  togglerCaVroomContent = () => {
    updateSCTags(this.state.toogleCaContent ? 'show more streaming devices' : 'show less streaming devices');
    this.setState({ toogleCaContent: !this.state.toogleCaContent })
  }

  handleKeyDownTvOption = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.props.showMoreTvOption(e);
    }
  }

  onCloseModal = () => {
    closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
  }

  onOpenModal = (id, servType) => {
    viewDetails(id, servType, this.props.visitId, this.props.dispatch);
    updateVzdlSCCustomEvent("prodView", "pageViewOmni", "");
    if (servType === Service.streamDev) {
      updateSCTags("learn about stream tv");
    }
  }

  handleDetailsLinkKeyDown = (e, id, servType) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      viewDetails(id, servType, this.props.visitId, this.props.dispatch);
      updateVzdlSCCustomEvent("prodView", "pageViewOmni", "");
    }
  }

  seeDetailsClick = (e, type) => {
    let usocList = '';
    if (this.props.products != undefined) {
      this.props.products.map((prd) => {
        usocList += prd.id + ",";
      })
    }
    usocList = usocList.slice(0, usocList.length - 1)
    seeFcpDetails("SEEDETAIL", this.props.visitId, this.props.dispatch, usocList);

  }

  getspecialOffer = (flowType, buildproductState, dispatch) => {
    if (InHomeUtils.isNotNull(buildproductState.tv) && InHomeUtils.isNotNull(buildproductState.tv.selectedProduct) && InHomeUtils.isNotNull(buildproductState.tv.selectedProduct.specialOffers)) {
      for (let offcount = 0; offcount < buildproductState.tv.selectedProduct.specialOffers.length; offcount++) {
        if (buildproductState.tv.selectedProduct.specialOffers[offcount].BsOfferAttrValue === OfferTypes.FiftyOfferPYP) {
          specialoffermsg = true;
        }
      }
    }
    if (flowType === "SUPP" && !buildproductState.splMsgPYP) {
      if (InHomeUtils.isNotNull(buildproductState.tv) && InHomeUtils.isNotNull(buildproductState.tv.selectedProduct)) {
        for (let suppcount = 0; suppcount < buildproductState.tv.m2mPlans.length; suppcount++) {
          //cart usoc and product usoc should be same 
          if (buildproductState.tv.selectedProduct.prodId != undefined && InHomeUtils.isNotNull(buildproductState.tv.selectedProduct.prodId)) {
            if (buildproductState.tv.m2mPlans[suppcount].id == buildproductState.tv.selectedProduct.prodId) {
              for (let sploffcount = 0; sploffcount < buildproductState.tv.m2mPlans[suppcount].specialOffers.length; sploffcount++) {
                if (buildproductState.tv.m2mPlans[suppcount].specialOffers[sploffcount].BsOfferAttrValue === OfferTypes.FiftyOfferPYP) {
                  specialoffermsg = true;
                  SuppSplOfferPYP(true, dispatch);
                }
              }
            }
          }
        }
      }
    }
    return specialoffermsg;
  }

  mySorter = (a, b) => {
    var x = parseFloat(a.displayPrice.replace('$', ''))
    var y = parseFloat(b.displayPrice.replace('$', ''));
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  }

  onNonSupportedLinkClick = () => {
    openModalWindow(ModalWindow.ids.unSupportedDetails, this.props.dispatch);
  }

  handleEmrgServRadio = (e)=> {
    this.props.dispatch({
      type:'EMERGENCY_SERVICES_NOTIFICATION_CHANGE',
      value: e.target.value
    })
  }

  onMobileInputChangeEmerg = (id, data)=>{
    onMobileInputChangeEmerg(data, this.props.dispatch, this.props.buildProduct, this.props.emergencyServicesEmail);
  }

  selectRadio = (e)=>{
    let emrgTiledValue = e.target.value === 'yes' ? 'yes' : e.target.value === 'no' ? 'no' : '';

    if(emrgTiledValue !== '' && (this.props.selectedProduct == "" || (this.props.selectedProduct && this.props.selectedProduct.value !== emrgTiledValue.toLowerCase()))){
      
        let selectedProductObject = {
            value: emrgTiledValue.toLowerCase(),
            prodType:'EmergencyServ'
        }
        this.props.dispatch({ type: "EMERGENCY_SERVICES_SELECTEDPROD", value: selectedProductObject, option: emrgTiledValue.toLowerCase() })
        if(emrgTiledValue.toLowerCase()== 'no'){
            this.props.dispatch({ type: "TOGGLE_EMERGENCY_SERVICES_ACCOR", value: '' })
        }
        else if(emrgTiledValue.toLowerCase()== 'yes'){
            tempVzdlSCData.detail = "Emergency Services";
            updateVzdlSCCustomEvent("emergencyServices", "sendData", "detail,subflow");
        }
        if(this.props.flowType == "SUPP"){
            this.props.dispatch({ type: "IS_SUPP_EMERGENCY_SELECTEDPROD", value: true });
        }
    }
  }

  onEmailInputChangeEmerg = (data)=>{
    onEmailInputChangeEmerg(data, this.props.dispatch, this.props.buildProduct, this.props.emergencyServicesMobile);
  }
  getSpecialBonusOffer = () => {
    let specailBonusOffertxt = '';
    if (InHomeUtils.isNotNull(this.props?.buildProduct?.internet?.selectedProduct?.specialOffers)) {
      // for (let offcount = 0; offcount < buildproductState.internet.selectedProduct.specialOffers.length; offcount++) {
      //   const offerAttrValue = buildproductState.internet.selectedProduct.specialOffers[offcount].BsOfferAttrValue;

      //   if (offerAttrValue === OfferTypes.VerizonGC100NMDA || offerAttrValue === OfferTypes.VerizonGC100 ||offerAttrValue === OfferTypes.Spcl25Incentive||offerAttrValue === OfferTypes.Spcl15Incentive || offerAttrValue === OfferTypes.VerizonGC200||offerAttrValue === OfferTypes.Verizon150GC|| offerAttrValue === OfferTypes.VerizonGC200NMDA || offerAttrValue === OfferTypes.VIXPREMIUM_12MO || offerAttrValue === OfferTypes.FIOS_XBOX_SERIES_S_ACQ_CM2024) {
      //     if(specailBonusOffertxt === ''){
      //       specailBonusOffertxt = buildproductState.internet.selectedProduct.specialOffers[offcount].OfferText;
      //     }
      //     else{
      //       specailBonusOffertxt = `${specailBonusOffertxt}, ${buildproductState.internet.selectedProduct.specialOffers[offcount].OfferText}`;
      //     }
      //   }
      // }
      const limitedOfferTypes = [OfferTypes?.VerizonGC100NMDA, OfferTypes?.VerizonGC100, OfferTypes?.Spcl25Incentive, OfferTypes?.Spcl20Incentive, OfferTypes?.Spcl15Incentive, OfferTypes?.VerizonGC200, OfferTypes?.Verizon150GC, OfferTypes?.VerizonGC200NMDA, OfferTypes?.VIXPREMIUM_12MO, OfferTypes?.FIOS_XBOX_SERIES_S_ACQ_CM2024, OfferTypes?.youtubePremium,OfferTypes?.NintendoSwitch];
      const specialOffersList = this.props?.buildProduct?.internet?.selectedProduct?.specialOffers?.filter?.(o => (
        typeof o?.OfferText === "string" && o?.OfferText !== ""
        && !this.props?.products?.some?.(p => p?.id === o?.id)
        && !o?.extendedAttributes?.includes?.("ISCHOICE:YES")
        && (
          limitedOfferTypes.includes(o?.BsOfferAttrValue)
          || (o?.BsOfferAttrValue === OfferTypes?.NetmaxOnUs && o?.USOCIOSC === "R4262") // Netmax
        )
      ))?.map?.(o => {
        return o?.OfferText;
      });
      specailBonusOffertxt = specialOffersList?.join?.(" and ");
    }
    return specailBonusOffertxt;
  }
  render() {
    const {isChanged} = this.state
    let detailLayout = "";
    let listItems = "";
    let tvListItems = null;
    let tvMoreOptions = null;
    let tvStreamServlist = null;
    let serviceType = "";
    let mm3Qualified = this.props.buildProduct.internet.mm3Qualified;
    let selectedProduct = this.props.selectedProduct;
    let selectedChannels = this.props.selectedChannels;
    let helperMsg = "";
    let tileImg = "";
    let perks = "";
    let channelMsg = "";
    let specialofferMsg = false;
    let OfferMsg = "";
    let voiceTn = this.props.voiceTN;
    let techSureLayout = '';
    let equipLayout = '';
    let internetLayout = '';
    let tvLayout = '';
    let discoveryCheck = '';
    let disoveryCheck = '';
    let discoverytitle = '';
    let discoverySubtitle = '';
    let notificationType = 'info';
    let discoveryoverlay = '';
    let notificationClassname = "hide";
    let hideCloseButton = true;
    let buttonData = '';
    let discoveryoverlayfun = '';
    let batteryLayout = '';
    let dctLayout = '';
    let listingLayout = '';
    let customTvLayout = '';
    let streamServPromo = '';
    let buildProduct = this.props.buildProduct;
    let lqState = this.props.lqState;
    let visitId = this.props.visitId;
    let modalWindow = this.props.modalWindow;
    let firstBill = this.props.firstBill;
    let dispatch = this.props.dispatch;
    let SublistItems = "";
    let hoaflow = InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.hoaFlowDetails) && lqState.hoaFlowDetails.isHoaFlow;
    let seeDetails = '';
    let seeDetailLayout = '';
    let alldIntrPkgOverlay = '';
    let headingMsg = '';
    let unsupportMsg = '';
    let hboUnSupportMsg = '';
    let isUnsupportMsg = false;
    let mobileTvAll = null;
    let mobileSpanish = null;
    let prodList = this.props.products;
    let isBHRx = false;
    let isCHR = false;
    let streamServlist = "";
    let vasChildList = "";
    let moreOptLink = "";
    let fcphelperMsg = "";
    let tvSublistItems = "";
    let spotlight_selected = this.props.buildProduct && this.props.buildProduct.tv && this.props.buildProduct.tv.selectedProduct && this.props.buildProduct.tv.selectedProduct.prodTypeVal && this.props.buildProduct.tv.selectedProduct.prodTypeVal === "Spotlight"
    let vasNewRow = "";
    let vroomNotification = "";
    let emergencySelfInstallMessage = null;
    let cloudAccStatus = "";
    let intCallingOverlay = "";
    let intlPlansOverlay = "";
    let InternetSublistItems = "";
    let showProdBanner = false;
    let showStreamTV = this.props.lqState?.runtimeKey?.showStreamTV === 'Y';
    let TVSoundbar = this.props.lqState?.runtimeKey?.TVSoundbar === 'Y';
    let stadiaOfferVerbiage = this.props.stadiaOfferVerbiage && ReactHtmlParser(this.props.stadiaOfferVerbiage) || '';
    let marvelOfferVerbiage = this.props.marvelOfferVerbiage && ReactHtmlParser(this.props.marvelOfferVerbiage) || '';
    let nydmaOfferVerbiage = this.props.nydmaOfferVerbiage && ReactHtmlParser(this.props.nydmaOfferVerbiage) || '';
    let suppHasSlingTV = (this.props.flowType === "SUPP" && this.props.suppHasSlingTV && this.props.suppHasSlingTV === "true") ? true : false;
    let isEmergency = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EmergencyNotification && this.props.lqState.runtimeKey.EmergencyNotification === 'Y';
    const isEmployee = this.props.lqState.couponFlowType === 'Employee' || this.props.lqState.couponFlowType === 'Retiree';

    const addProdBanner = (prodType, includedKey, productsKey) => {
      // For midnight, included item should be displayed first in the list
      const includedItem = this.props.buildProduct[prodType].selectedProduct;
      let idx = 0;
      showProdBanner = true;

      let selectedData = '';
      if(prodType === 'router') {
        selectedData = this.props.buildProduct.internet.selectedProduct?.name?.replace('4.0', '');
      }

      const bannerText = {
        router: 'Included with your ' + selectedData + ' plan',
        recording: 'Included with your TV plan'
      };

      if(prodType === 'router') {
        // Removing Buy: Verizon Router option for Midnight
        prodList = prodList?.filter(item => (item.id !== 'R0704' || item.id !== 'R0703'));
      }

      prodList?.find((item, index) => {
        if(item.id == "R1767") {
          item['banner'] = (selectedData?.indexOf("1 Gig") > -1  || selectedData?.indexOf("2 Gig") > -1 ) ? 'Included with your ' + selectedData + ' plan' : '';
        }
        else if(this.props?.buildProduct?.isMonarchView && item?.name === "Whole-Home Wi-Fi Plus") {
          item['banner'] = item?.displayPrice?.indexOf("$5.00") > -1 ? "Save " + "$10/mo" + " with your " + selectedData + " plan" : item['banner'];
        }
      });
      
      // Adding banner for the included item
      if(includedItem) {
        const findItem = prodList?.find((item, index) => {
          if(item[productsKey] === includedItem[includedKey]) {
            idx = index;
            if(item.displayPrice =='Included' || item.displayPrice == '$0' || item.displayPrice == '$0.00') {
              item['banner'] = bannerText[prodType];
            }
            return true;
          }

        });
        if(findItem) {
          prodList.splice(idx, 1);
          prodList.unshift({ ...findItem });
        }
      }

      
  };

    if (this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.router) && InHomeUtils.isNotNull(this.props.buildProduct.router.equipments) && this.props.buildProduct.router.equipments.length > 0) {
      isBHRx = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.toLowerCase().indexOf('|bhrx|') !== -1).length > 0 ? true : false;
      isCHR = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.toLowerCase().indexOf('|chr|') !== -1).length > 0 ? true : false;
    }
    let tileMessage = (this.props.toggleRouterMoreOption) ? 'See less options' : 'See more options';
    let tileIcon = (this.props.toggleRouterMoreOption) ? 'vzicon icon-minus-alt' : 'vzicon icon-plus-alt';

    if ((InHomeUtils.isNotNull(this.props.products) && this.props.products.length > 0) || suppHasSlingTV) {
      if (InHomeUtils.isNotNull(this.props.products) && this.props.products.length > 0) {
        serviceType = getServiceType(this.props?.products?.[0]?.prodType || this.props?.products?.[0]?.productType);
        if (serviceType === "TECHSURE" && this.props.products[0].isVCloudProd === "Yes") {
          cloudAccStatus = true;
        }
        if(serviceType === Service.internet && (this.props.products[0].prodTypeValue === "COMPLETE" || this.props.products[0].prodTypeValue === "STREAMING" || this.props.products[0].prodTypeValue === "GAMING" ))
        {
          serviceType = "MM3";
        }
      }
      if (serviceType === Service.router && isBHRx) {
        let tempBHRX = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|BHRX|') !== -1 && p.keyword.indexOf('AutoAddExtender:R0642') === -1 && p.keyword.indexOf('AUTOADDEXTENDER:R0840') === -1);
        let nonBHRX = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|BHRX|') === -1 && p.keyword.indexOf('PROVIDED') === -1 && p.keyword.indexOf('AUTOADDEXTENDER:R0840') === -1 && p.keyword.indexOf('AutoAddExtender:R0642') === -1);
        let WHWRouter = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && (p.keyword.indexOf('AutoAddExtender:R0642') > -1 || p.keyword.indexOf('AUTOADDEXTENDER:R0840') > -1));
        let ownRouter = this.props.buildProduct.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('PROVIDED') !== -1 && (p.keyword.indexOf('VVPROUTER') === -1 && p.prodTypeValue !== "VZROUTER_NOT_CHARGED_CONSUMER"));
        if (InHomeUtils.isNotNull(tempBHRX) && tempBHRX.length > 0 && tempBHRX.filter(p => p.displayPrice != null).length > 0) {
          tempBHRX.sort(this.mySorter)
        }
        if (InHomeUtils.isNotNull(nonBHRX) && nonBHRX.length > 0 && nonBHRX.filter(p => p.displayPrice != null).length > 0) {
          nonBHRX.sort(this.mySorter)
        }
        if(mm3Qualified)
      {
          prodList = this.props.buildProduct.router.equipments;
        }
        else{
         prodList = [...WHWRouter, ...nonBHRX, ...tempBHRX, ...ownRouter]
        } 
      }
      else {
        prodList = this.props.products;
        if (serviceType === Service.tv && this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.streamServ)) {
          //(InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct) || (lqState.showNewYoutubeChanges))
          var tvplans = this.props.products;
          var streamtv = InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.hoaFlowDetails) && lqState.hoaFlowDetails.isHoaFlow
            ? [] :
            this.props.buildProduct.streamServ.streamServProd;
          if (tvplans && streamtv) {
            prodList = [...tvplans, ...streamtv];
          }
          if (InHomeUtils.isNull(tvplans) && InHomeUtils.isNotNull(suppHasSlingTV) && !InHomeUtils.isNotEmpty(serviceType)) {
            prodList = streamtv;
          }
        }
        else if (this.props.flowType === "SUPP" && InHomeUtils.isNotNull(suppHasSlingTV) && suppHasSlingTV && !InHomeUtils.isNotEmpty(serviceType) && this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.streamServ) && InHomeUtils.isNotNull(this.props.buildProduct.streamServ.streamServProd)
          && this.props.buildProduct.streamServ.selectedProduct) {
          var streamtv = InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.hoaFlowDetails) && lqState.hoaFlowDetails.isHoaFlow
            ? [] :
            this.props.buildProduct.streamServ.streamServProd;
          prodList = streamtv;
          serviceType = Service.tv;
        }

      }

      if(this.props.buildProduct.isMNEnabled && this.props.buildProduct.internet.selectedProduct && serviceType === Service.router) {
        addProdBanner('router', 'prodId', 'id');
      }

      if(serviceType === Service.splOffer){
        console.log('sploffer',prodList);
        let selectedData = '';
        selectedData = this.props.buildProduct?.internet?.selectedProduct?.name?.replace('4.0', '');
        prodList?.find((item, index) => {
            item['banner'] = (selectedData?.indexOf("1 Gig") > -1  || selectedData?.indexOf("2 Gig") > -1 || selectedData?.indexOf("500 Mbps") > -1 ) ? 'Included with your ' + selectedData + ' plan' : '';
        });
      }

      /*if(serviceType === Service.techSure && lqState.selectedState.state !== "NY") {
        prodList =  prodList.filter(p => p.name !== null && p.name.indexOf('Inside Wire') === -1 );
      }*/

      // Order Data tiles for Supp flow
      if(prodList?.length > 0 && serviceType === Service.internet) {
        const dataOrder = {
          R3588: '1', // 100 mbps
          R3586: '2', // 300 mbps
          R3584: '3', // 500 mbps - max
          R3587: '1', // 300mpbs
          R3585: '2', // 500mpbs
          R3583: '3', // 1gig
          R3582: '4', //2 gig
        }
        prodList?.sort((a,b) => { return dataOrder[a.id] - dataOrder[b.id]; })
      }

      listItems =
        prodList &&
        prodList.map((product, index) => {
          //AR old code start  //
          // if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.prodType) && product.prodType !== Service.streamServ && product.prodTypeValue !== "LOCLDGTL" && product.prodTypeValue !== "MUNDO" && product.prodTypeValue !== "MUNDO_TOTAL" && (product.prodTypeValue !== "Spotlight" || (spotlight_selected && product.prodTypeValue === "Spotlight") ) )
          //AR old code end  //

          if (
            InHomeUtils.isNotNull(product) &&
            InHomeUtils.isNotNull(product?.prodType) &&
            product?.prodType !== Service?.streamServ &&
            product?.prodTypeValue !== "LOCLDGTL" &&
            product?.prodTypeValue !== "Fios_Five" &&
            (product?.prodTypeValue !== "Spotlight" ||
              (spotlight_selected && product?.prodTypeValue === "Spotlight")) &&
            ((this.props?.buildProduct?.isECMNEnabled) || !mm3Qualified
              ? true
              : (product.prodTypeValue !== "MUNDO" &&
                product.prodTypeValue !== "MUNDO_TOTAL"))
          ) {
            let isChecked = false;
            if (InHomeUtils.isNotNull(selectedProduct)) {
              // remove this if block to enable VAS products multiple selection
              /* if(typeof(selectedProduct) === "object" && serviceType === Service.techSure) {
               selectedProduct = selectedProduct.prodId;
             }*/
              isChecked =
                serviceType === Service.router
                  ? product.id === selectedProduct.id ||
                    product.id === selectedProduct.prodId
                  : false;
              isChecked =
                serviceType === Service.channel ||
                serviceType === Service.intrnlChnl ||
                serviceType === Service.techSure
                  ? InHomeUtils.isNotNull(selectedProduct) &&
                    selectedProduct.indexOf(product.id) > -1
                  : serviceType === Service.winBack ||
                    serviceType === Service.splOffer ||
                    serviceType === Service.flashOffer
                  ? product.id === selectedProduct.id
                  : serviceType === Service.streamDevCount
                  ? product.unitCount === selectedProduct.unitCount
                  : (selectedProduct &&
                      serviceType !== "MM3" &&
                      product.downSpeed &&
                      product.downSpeed === selectedProduct.downSpeed) ||
                    product.id === selectedProduct.id ||
                    product.id === selectedProduct.prodId;
            }

            if (
              serviceType === Service.tv &&
              InHomeUtils.isNotNull(product.prodTypeValue) &&
              product.prodTypeValue.length > 0 &&
              product.prodTypeValue !== "CUSTOM_GENERIC" &&
              product.prodTypeValue.indexOf("CUSTOM") > -1
            ) {
              serviceType = Service.customTV;
            }
            if (
              serviceType === Service.router &&
              InHomeUtils.isNotNull(product.prodTypeValue) &&
              product.prodTypeValue.length > 0 &&
              product.prodTypeValue.indexOf("PROVIDED") > -1
            ) {
              serviceType = "CUSTOMROUTER";
            } else if (
              InHomeUtils.isNotNull(product.prodTypeValue) &&
              product.prodTypeValue.length > 0 &&
              (product.prodTypeValue.indexOf("ROUTER") > -1 ||
                product.prodTypeValue.indexOf("MRC") > -1)
            ) {
              serviceType = Service.router;
            }

            /*
          if(InHomeUtils.isNotNull(product.prodTypeValue) && product.prodTypeValue === Service.youtubeReferal){
            if(InHomeUtils.isNotNull(buildProduct) && InHomeUtils.isNotNull(buildProduct.disclaimerContentFragments) && InHomeUtils.isNotNull(buildProduct.disclaimerContentFragments["StreamingServices"])){
              let disclaimerStreaming = buildProduct.disclaimerContentFragments["StreamingServices"];
              if (InHomeUtils.isNotNull(disclaimerStreaming) && InHomeUtils.isNotEmpty(disclaimerStreaming.promo)  && disclaimerStreaming.promo !== "<p>N/A</p>"){
                  streamServPromo = <PromoMessage message={disclaimerStreaming.promo} />;
              }
            }
          }
          */

            /* AR TV Live TV old code start*/
            if (
              !(this.props?.buildProduct?.isECMNEnabled) &&
              lqState.isFCPflow === true &&
              serviceType === Service.tv
            ) {
              if (mm3Qualified &&
                (product.prodType === "BASIC" ||
                  product.prodType === "BASICDIFF") &&
                product.prodTypeValue !== "LOCLDGTL" &&
                product.prodTypeValue !== "MUNDO" &&
                product.prodTypeValue !== "MUNDO_TOTAL"
              ) {
                return (
                  <Tile
                    flowType={this.props.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props.recommendedTV}
                    suppSelectedProds={this.props.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            }
            /* AR TV Live TV old code end*/

            if (
               (this.props?.buildProduct?.isECMNEnabled) &&
              lqState.isFCPflow === true &&
              serviceType === Service.tv &&
              !this?.props?.buildProduct?.tv?.spanishTV
            ) {
              if (
                (product.prodType === "BASIC" ||
                  product.prodType === "BASICDIFF") &&
                product.prodTypeValue !== "LOCLDGTL" &&
                product?.prodTypeValue !== "Fios_Five" &&
                product.prodTypeValue !== "MUNDO" &&
                product.prodTypeValue !== "MUNDO_TOTAL"
              ) {
                const formattedProd = formatTVProduct(
                  product,
                  buildProduct?.plansPromoFragments,
                  !buildProduct.mnFromApi,
                  this.props?.appState,
                );
                const prod = { ...product, ...formattedProd };
                return (
                  <Tile
                    midniteProd={prod}
                    showProdBanner={showProdBanner}
                    flowType={this.props?.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props?.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props?.recommendedTV}
                    suppSelectedProds={this.props?.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            } 
            else if (
              !mm3Qualified &&
              // lqState.isFCPflow === true &&
              serviceType === Service.tv &&
              !this?.props?.buildProduct?.tv?.spanishTV
            ) {
              if (
                (product.prodType === "BASIC" ||
                  product.prodType === "BASICDIFF") &&
                product.prodTypeValue !== "LOCLDGTL" &&
                product?.prodTypeValue !== "Fios_Five" &&
                product.prodTypeValue !== "MUNDO" &&
                product.prodTypeValue !== "MUNDO_TOTAL"
              ) {
                return (
                  <Tile
                    showProdBanner={showProdBanner}
                    flowType={this.props?.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props?.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props?.recommendedTV}
                    suppSelectedProds={this.props?.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            } 
            else if (
               (this.props?.buildProduct?.isECMNEnabled) &&
              lqState?.isFCPflow === true &&
              serviceType === Service?.tv &&
              this?.props?.buildProduct?.tv?.spanishTV
            ) {
              // if ((product.prodType === "BASIC" || product.prodType === "BASICDIFF") && product.prodTypeValue !== "LOCLDGTL" && product.prodTypeValue !== "MUNDO" && product.prodTypeValue !== "MUNDO_TOTAL" ) {
              if (
                (product?.prodType === "BASIC" ||
                  product?.prodType === "BASICDIFF") &&
                product?.prodTypeValue !== "LOCLDGTL" &&
                product?.prodTypeValue !== "ULTIMATE" &&
                product?.prodTypeValue !== "PREFERRED" &&
                product?.prodTypeValue !== "Fios_Five" &&
                product?.prodTypeValue !== "ULTIMATETESTDRIVE"
              ) {
                const formattedProd = formatTVProduct(
                  product,
                  buildProduct?.plansPromoFragments,
                  !buildProduct.mnFromApi,
                  this.props?.appState,
                );
                const prod = { ...product, ...formattedProd };
                return (
                  <Tile
                    midniteProd={prod}
                    showProdBanner={showProdBanner}
                    flowType={this.props.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props.recommendedTV}
                    suppSelectedProds={this.props.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            } 
            else if (
              !mm3Qualified &&
              // lqState?.isFCPflow === true &&
              serviceType === Service?.tv &&
              this?.props?.buildProduct?.tv?.spanishTV
            ) {
              // if ((product.prodType === "BASIC" || product.prodType === "BASICDIFF") && product.prodTypeValue !== "LOCLDGTL" && product.prodTypeValue !== "MUNDO" && product.prodTypeValue !== "MUNDO_TOTAL" ) {
              if (
                (product?.prodType === "BASIC" ||
                  product?.prodType === "BASICDIFF") &&
                product?.prodTypeValue !== "LOCLDGTL" &&
                product?.prodTypeValue !== "ULTIMATE" &&
                product?.prodTypeValue !== "PREFERRED" &&
                product?.prodTypeValue !== "Fios_Five" &&
                product?.prodTypeValue !== "EXTREME" &&
                product?.prodTypeValue !== "CUSTOM_GENERIC" &&
                product?.prodTypeValue !== "ULTIMATETESTDRIVE"
              ) {
                return (
                  <Tile
                    showProdBanner={showProdBanner}
                    flowType={this.props.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props.recommendedTV}
                    suppSelectedProds={this.props.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            }             
            else if (
              (serviceType === Service.router ||
                serviceType == Service.customRouter) &&
              this.props.buildProduct.isSelectedData500Or400
            ) {
              if (product.name.toLowerCase().includes("whole") || product.name.toLowerCase().includes("rent")) {
                let prod = undefined;
                if((this.props?.buildProduct?.isECMNEnabled)) {
                  const formattedProd = formatProduct(
                    product,
                    buildProduct.plansPromoFragments,
                    !buildProduct.mnFromApi, serviceType, buildProduct, this.props?.appState
                  );

                  prod = { ...product, ...formattedProd };
                }
                return (
                  <Tile midniteProd={prod} showProdBanner={showProdBanner} cart={this.props.cart} flowType={this.props.flowType} product={product} serviceType={serviceType} cloudAccStatus={cloudAccStatus} key={index} index={index} isChecked={isChecked} voiceTn={voiceTn} buildProduct={buildProduct} lqState={lqState}
                    visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} recommendedTV={this.props.recommendedTV} isSubOffer={this.props.isSubOffer} isDataOffer={this.props.isDataOffer} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={selectedProduct} container={this.props.container} supphasPreholidayGC={this.props.supphasPreholidayGC} supphashasBlackFriday={this.props.supphashasBlackFriday} />
                )
              }
              else {
                return "";
              }
            } else {
              /* Just added below if so other script doesn't break for other types.. can remove once all types are added
               */
              // if(product?.prodType === 'FTTPD') {
                if(product.id == "R1824"){
                  let price = product.displayPrice.split(" ")[0];
                  let price1 = product.displayPrice.split(" ")[1];
                  let price2 = price.split(".")[0]+' '+price1;
                  // product.displayPrice = price2;
                 
                }

                if(product.id == 'WINBACKYES'){
                  product.name = "I'd like to  keep my current number.";
                  product.displayPrice = product.displayPrice.split(" ")[0];
                } else if(product.id == 'WINBACKNO'){
                  product.name = "I'd like a new phone number.";
                  product.displayPrice = 'Included';
                } 

                if(product.name?.indexOf('List my number') == 0){
                  product.name = "I want to list my number";
                }

                if(product.name?.indexOf(`No, I don't want a PowerReserve`) > -1){
                  product.name = "I don’t want a Power Reserve";
                }

                if(product.name?.indexOf("Yes, I'd like a PowerReserve") > -1){
                  product.name = "I'd like a Power Reserve";
                }

              
              const formattedProd = formatProduct(
                product,
                buildProduct.plansPromoFragments,
                !buildProduct.mnFromApi, serviceType, buildProduct, this.props?.appState
              );
              const prod = { ...product, ...formattedProd };
              // return <MnTile product={prod} />;
              let isBlocked = false;
              if (
                !this.props?.isBFxBoxSeriesInSplOffer &&
                this.props?.BFxBoxSeriesInProfile?.length > 0 &&
                prod?.id === "R4093"
              ) {
                isBlocked = true;
                isChecked = true;
              }else if( !this.props?.isBFxBoxBundleInSplOffer &&
                this.props?.BFxBoxBundleInProfile?.length > 0 &&
                prod?.id === "R4049"
              ){
                  isBlocked = true;
                  isChecked = true;
              }else if( !this.props?.isNetmaxInSplOffer &&
                this.props?.BFNetmaxInProfile?.length > 0 &&
                prod?.id === "R4047"
              ){
                  isBlocked = true;
                  isChecked = true;
              }

              console.log("BF offer testing",prod?.id,this.props?.BFxBoxSeriesInProfile,this.props?.BFxBoxBundleInProfile,this.props?.BFNetmaxInProfile)
              return (
                <Tile
                  midniteProd={prod}
                  showProdBanner={showProdBanner}
                  cart={this.props.cart}
                  flowType={this.props.flowType}
                  product={product}
                  serviceType={serviceType}
                  cloudAccStatus={cloudAccStatus}
                  key={index}
                  index={index}
                  isChecked={isChecked}
                  voiceTn={voiceTn}
                  buildProduct={buildProduct}
                  lqState={lqState}
                  visitId={visitId}
                  visitorId={this.props.visitorId}
                  modalWindow={modalWindow}
                  firstBill={firstBill}
                  dispatch={dispatch}
                  recommendedTV={this.props.recommendedTV}
                  isSubOffer={this.props.isSubOffer}
                  isDataOffer={this.props.isDataOffer}
                  suppSelectedProds={this.props.suppSelectedProds}
                  selectedProduct={selectedProduct}
                  container={this.props.container}
                  supphasPreholidayGC={this.props.supphasPreholidayGC}
                  supphashasBlackFriday={this.props.supphashasBlackFriday}
                  acc={this.state.acc}
                  isBlocked={isBlocked}
                  onClickAccordion={this.onClickAccordion}
                  tilesOrderFlag={!this.props.buildProduct.tilesOrderDesignFlag && (this.props.flowType === 'NC' || this.props.flowType === 'MV') && getServiceType(this.props.products[0].prodType) === Service.internet}
                  isPremiumProduct={parseInt(product?.downSpeed?.replace(/\D/g,'')) > 500 || (index === prodList?.length - 1 && parseInt(product?.downSpeed?.replace(/\D/g,'')) === 500)}
                />
              );
              // }
            }
          }
        });

      if (
        (serviceType === Service.router ||
          serviceType == Service.customRouter) &&
        this.props.buildProduct.isSelectedData500Or400
      ) {
        let isChecked = false;
        let SublistItems = prodList && prodList.map((product, index) => {
            if (
              serviceType === Service.router &&
              InHomeUtils.isNotNull(product.prodTypeValue) &&
              product.prodTypeValue.length > 0 &&
              product.prodTypeValue.indexOf("PROVIDED") > -1
            ) {
              serviceType = "CUSTOMROUTER";
            } else if (
              InHomeUtils.isNotNull(product.prodTypeValue) &&
              product.prodTypeValue.length > 0 &&
              (product.prodTypeValue.indexOf("ROUTER") > -1 ||
                product.prodTypeValue.indexOf("MRC") > -1)
            ) {
              serviceType = Service.router;
            }
            isChecked = product.id === selectedProduct.id || product.id === selectedProduct.prodId;
            if ((!product.name.toLowerCase().includes("whole") && !product.name.toLowerCase().includes("rent"))) {
            let prod = undefined;
            if((this.props?.buildProduct?.isECMNEnabled)) {
              const formattedProd = formatProduct(
                product,
                buildProduct.plansPromoFragments,
                !buildProduct.mnFromApi, serviceType, buildProduct, this.props?.appState
              );
              prod = { ...product, ...formattedProd };
            }
            return (
              <Tile midniteProd={prod} showProdBanner={showProdBanner} cart={this.props.cart} flowType={this.props.flowType} product={product} serviceType={serviceType} cloudAccStatus={cloudAccStatus} key={index} index={index} isChecked={isChecked} voiceTn={voiceTn} buildProduct={buildProduct} lqState={lqState}
                visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} recommendedTV={this.props.recommendedTV} isSubOffer={this.props.isSubOffer} isDataOffer={this.props.isDataOffer} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={selectedProduct} container={this.props.container} supphasPreholidayGC={this.props.supphasPreholidayGC} supphashasBlackFriday={this.props.supphashasBlackFriday} />
            );
          }
          });
        listItems = (
          <React.Fragment>
            {listItems}
            {!this.props.toggleRouterMoreOption ? SublistItems : ""}
            {this.props.toggleRouterMoreOption && (
              <div
                id="TVShowLessMore"
                className="w_blocks"
                iscustomgeneric="false"
                role="tablist"
                onClick={(e) => this.props.showMoreRouterOption(e)}
                onKeyDown={(e) => this.props.showMoreRouterOption(e)}
              >
                <div
                  className="blocks_equipment-more-less"
                  data-customer-selection=""
                  role="tab"
                  aria-selected="false"
                  tabIndex="0"
                >
                  <div className="left p-80 padding-horiz-large margin-horiz-large margin-vert-tiny">
                    <p className="text-center margin-bottom-micro">
                      <span className={tileIcon} aria-hidden="true"></span>
                    </p>
                    <p className="text-black bold text-large text-center padding-vert-small margin-all-zero">
                      {tileMessage}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      }

    
      //Perks section Start
      let perkList = [];
      let perkListobj = {};
      if (serviceType === Service?.perks) {
        if (prodList && prodList?.length > 0) {
          //Check for grouping Perks if it is UNLIMITED_CLOUD_STORAGE or APPLE_ONE
          prodList = prodList.map((item) => {
            let data = { ...item };
            if (
              item.productId === constants.UNLIMITED_CLOUD_INDIVIDUAL ||
              item.productId === constants.APPLE_ONE_INDIVIDUAL ||
              item.productId === constants.HOME_DEVICE_ADVISOR
            ) {
              let groudId = InHomeUtils.findGroupIdWith(item.productId);
              if(InHomeUtils.isNotEmpty(groudId)){
                data['group'] = [item,prodList.find(vl => vl.productId === groudId)];
              }  
            }
            return data;
          });
        }
        const perksOrder = {
          R3559: 1, // Netflix & Max
          R3558: 2, // Disney Bundle
          R4438: 3, // Disney Trio
          R3556: 4, // Apple One
          R3557: 4, // Apple One Family
          R3554: 5, // Walmart
          R3555: 6, // Apple Music
          R3680: 7, // Youtube Premium
          R3551: 8, // +play
          R3552: 9, // Unlimited cloud storage
          R3553: 9, // Unlimited cloud group
          R3731: 10, // Verizon Home Advisor
          R4224: 11, // Google one permium
        };
        prodList.sort((a, b) => {
          return perksOrder[a.productId] - perksOrder[b.productId];
        });
        perks =
          prodList &&
          prodList.map((product) => {
            const formattedPerks = formatPerks(product,this.props.buildProduct,this.props.lqState);
            const perkDetail = { ...formattedPerks };
            perkListobj[formattedPerks.data.id] = formattedPerks;
            perkDetail?.perkDetails?.length > 0 &&
              perkList.push(formattedPerks);
            let isValidServiceType = perkDetail?.data?.productType === 'BYOPERK';
            let newServiceType = isValidServiceType ? Service?.perks : serviceType
            if (
              newServiceType === Service?.perks &&
              InHomeUtils.isNotNull(product?.productTypeValue) &&
              product.productId !== constants.UNLIMITED_CLOUD_GROUP && 
                product.productId !== constants.APPLE_ONE_FAMILY &&
              (this.props.lqState?.runtimeKey?.enableApplePerk === 'Y' || (
                product.productId !== constants.APPLE_MUSIC_FAMILY &&
                product.productId !== constants.APPLE_ONE_INDIVIDUAL)) &&
              product.productId !== constants.VERIZON_HOME_DEVICE_PROTECT
            ) {
              return (
                perkDetail?.perkDetails?.length > 0 && (
                  <PerkTile
                    product={perkDetail}
                    perkList={perkList}
                    perkListobj={perkListobj}
                    selectedProduct={selectedProduct}
                    dispatch={dispatch}
                  />
                )
              );
            }
          });
      }
  //Perks section End

  if (serviceType !== Service.customTV) {
    streamServlist =
      prodList &&
      prodList.map((product, index) => {
        //serviceType = this.getServiceType(this.props.products[0].prodType);
        let isChecked =
          serviceType === Service.channel
            ? selectedProduct.indexOf(product.id) > -1
            : serviceType === Service.winBack ||
              serviceType === Service.splOffer
            ? product.id === selectedProduct.id
            : serviceType === Service.streamDevCount
            ? product.unitCount === selectedProduct.unitCount
            : (InHomeUtils.isNotNull(product.downSpeed) &&
                InHomeUtils.isNotEmpty(product.downSpeed) &&
                product.downSpeed === selectedProduct &&
                selectedProduct.downSpeed) ||
              (selectedProduct &&
                (product.id === selectedProduct.id ||
                  product.id === selectedProduct.prodId));
        if (product.prodTypeValue === Service.slingtv) {
          if (this.props.buildProduct.streamServ.selectedProduct) {
            let selectedStreamingProducts =
              this.props.buildProduct.streamServ.selectedProduct;
            if (selectedStreamingProducts) {
              if (
                selectedStreamingProducts.id === product.id ||
                selectedStreamingProducts.prodId === product.id
              ) {
                isChecked = true;
              }
            }
          }
        }
        /* AR streamServ old code start */
        if (
          !(this.props?.buildProduct?.isECMNEnabled) && !this.props.buildProduct.tv.spanishTV &&
          product.prodType === Service.streamServ && (!mm3Qualified ? product.prodTypeValue !== Service.slingtv : true)
        ) {
          return (
            <Tile
              flowType={this.props.flowType}
              product={product}
              serviceType={serviceType}
              cloudAccStatus={cloudAccStatus}
              key={index}
              isChecked={isChecked}
              voiceTn={voiceTn}
              buildProduct={buildProduct}
              lqState={lqState}
              visitId={visitId}
              visitorId={this.props.visitorId}
              modalWindow={modalWindow}
              firstBill={firstBill}
              dispatch={dispatch}
              recommendedTV={this.props.recommendedTV}
              suppSelectedProds={this.props.suppSelectedProds}
              selectedProduct={selectedProduct}
              suppHasSlingTV={suppHasSlingTV}
            />
          );
        }

        /* AR streamServ old code end */

        if (
           (this.props?.buildProduct?.isECMNEnabled) &&
          product.prodType === Service.streamServ && product.prodTypeValue !== Service.slingtv
        ) {
          //Format data for Midnight
          const formattedProd = formatTVProduct(
            product,
            buildProduct.plansPromoFragments,
            !buildProduct.mnFromApi,
            this.props?.appState,
          );
          const prod = { ...product, ...formattedProd };

          return (
            <Tile
              midniteProd={prod}
              showProdBanner={showProdBanner}
              flowType={this.props.flowType}
              product={product}
              serviceType={serviceType}
              cloudAccStatus={cloudAccStatus}
              key={index}
              isChecked={isChecked}
              voiceTn={voiceTn}
              buildProduct={buildProduct}
              lqState={lqState}
              visitId={visitId}
              visitorId={this.props.visitorId}
              modalWindow={modalWindow}
              firstBill={firstBill}
              dispatch={dispatch}
              recommendedTV={this.props.recommendedTV}
              suppSelectedProds={this.props.suppSelectedProds}
              selectedProduct={selectedProduct}
              suppHasSlingTV={suppHasSlingTV}
            />
          );
        }
      });
  }
      /*if (serviceType === "TECHSURE" && lqState.selectedState.state !== "NY") {
        let vasnewlist = "";
        vasNewRow = buildProduct.techsure.techsureProducts && buildProduct.techsure.techsureProducts.map((product, index) => {
          let isChecked = (serviceType === "TECHSURE") ? selectedProduct.indexOf(product.id) > -1 : (serviceType === Service.winBack || serviceType === Service.splOffer) ? (product.id === selectedProduct.id) :
            (serviceType === Service.streamDevCount) ? product.unitCount === selectedProduct.unitCount : (InHomeUtils.isNotNull(product.downSpeed) && product.downSpeed === selectedProduct.downSpeed) || (product.id === selectedProduct.id || product.id === selectedProduct.prodId);

          if (product.name.indexOf("Inside Wire") > -1) {
            vasnewlist = <Tile flowType={this.props.flowType} product={product} serviceType={serviceType} key={index} isChecked={isChecked} voiceTn={voiceTn} buildProduct={buildProduct} lqState={lqState} visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} recommendedTV={this.props.recommendedTV} enableVasChildList={this.props.buildProduct.techsure.enableVasChildList} suppSelectedProds={this.props.suppSelectedProds}  selectedProduct={selectedProduct} />
          }
          return vasnewlist;
        });
      }*/

      if ( !(this.props?.buildProduct?.isECMNEnabled) && this.props.buildProduct && this.props.buildProduct.techsure.enableVasChildList && serviceType === "TECHSURE") {
        let filterVasList = "";
        let prdArr = selectedProduct.split(',');
        vasChildList = buildProduct.techsure.vasChildList && buildProduct.techsure.vasChildList.map((product, index) => {
          let isChecked = (serviceType === "TECHSURE") ? selectedProduct.indexOf(product.id) > -1 : (serviceType === Service.winBack || serviceType === Service.splOffer) ? (product.id === selectedProduct.id) :
            (serviceType === Service.streamDevCount) ? product.unitCount === selectedProduct.unitCount : (InHomeUtils.isNotNull(product.downSpeed) && product.downSpeed === selectedProduct.downSpeed) || (product.id === selectedProduct.id || product.id === selectedProduct.prodId);
          prdArr.map((pId, i) => {
            //<div><p class="tiny-margin-top-small bold margin-bottom-zero tiny-padding-left-tiny">Need Additional Services?</p></div>             
            if (InHomeUtils.isNotEmpty(pId[i]) && product.childOf.indexOf(pId) > 1) {
              filterVasList = <Tile flowType={this.props.flowType} product={product} serviceType={serviceType} cloudAccStatus={cloudAccStatus} key={index} isChecked={isChecked} voiceTn={voiceTn} buildProduct={buildProduct} lqState={lqState} visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} recommendedTV={this.props.recommendedTV} enableVasChildList={this.props.buildProduct.techsure.enableVasChildList} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={selectedProduct} />
            }
          });
          return filterVasList;
        });
      }

      if (
         (this.props?.buildProduct?.isECMNEnabled) &&
        this.props.buildProduct &&
        this.props.buildProduct.techsure.enableVasChildList &&
        serviceType === "TECHSURE"
      ) {
        //Format data for Midnight
        const formattedProd = formatProduct(
          product,
          buildProduct.plansPromoFragments,
          !buildProduct.mnFromApi, serviceType, buildProduct, this.props?.appState
        );
        const prod = { ...product, ...formattedProd };

        let filterVasList = "";
        let prdArr = selectedProduct.split(",");
        vasChildList =
          buildProduct.techsure.vasChildList &&
          buildProduct.techsure.vasChildList.map((product, index) => {
            let isChecked =
              serviceType === "TECHSURE"
                ? selectedProduct.indexOf(product.id) > -1
                : serviceType === Service.winBack ||
                  serviceType === Service.splOffer
                ? product.id === selectedProduct.id
                : serviceType === Service.streamDevCount
                ? product.unitCount === selectedProduct.unitCount
                : (InHomeUtils.isNotNull(product.downSpeed) &&
                    product.downSpeed === selectedProduct.downSpeed) ||
                  product.id === selectedProduct.id ||
                  product.id === selectedProduct.prodId;
            prdArr.map((pId, i) => {
              //<div><p class="tiny-margin-top-small bold margin-bottom-zero tiny-padding-left-tiny">Need Additional Services?</p></div>
              if (
                InHomeUtils.isNotEmpty(pId[i]) &&
                product.childOf.indexOf(pId) > 1
              ) {
                filterVasList = (
                  <Tile
                    midniteProd={prod}
                    showProdBanner={showProdBanner}
                    flowType={this.props.flowType}
                    product={product}
                    serviceType={serviceType}
                    cloudAccStatus={cloudAccStatus}
                    key={index}
                    isChecked={isChecked}
                    voiceTn={voiceTn}
                    buildProduct={buildProduct}
                    lqState={lqState}
                    visitId={visitId}
                    visitorId={this.props.visitorId}
                    modalWindow={modalWindow}
                    firstBill={firstBill}
                    dispatch={dispatch}
                    recommendedTV={this.props.recommendedTV}
                    enableVasChildList={
                      this.props.buildProduct.techsure.enableVasChildList
                    }
                    suppSelectedProds={this.props.suppSelectedProds}
                    selectedProduct={selectedProduct}
                  />
                );
              }
            });
            return filterVasList;
          });
      }

      tvSublistItems =
        prodList &&
        prodList.map((product, index) => {
          //serviceType = this.getServiceType(this.props.products[0].prodType);
          let isChecked =
            serviceType === Service.channel
              ? selectedProduct?.indexOf(product.id) > -1
              : serviceType === Service.winBack ||
                serviceType === Service.splOffer
              ? product.id === selectedProduct?.id
              : serviceType === Service.streamDevCount
              ? product.unitCount === selectedProduct?.unitCount
              : (InHomeUtils.isNotNull(product.downSpeed) &&
                  product.downSpeed === selectedProduct?.downSpeed) ||
                product.id === selectedProduct?.id ||
                product.id === selectedProduct?.prodId;
          /*AR tv tvSublistItems old code start*/
          if (
            !(this.props?.buildProduct?.isECMNEnabled) &&
            InHomeUtils.isNotNull(product) &&
            InHomeUtils.isNotNull(product.prodType) &&
            this.props.toggleTVMoreOption &&
            (!mm3Qualified ? (!this.props.buildProduct.tv.spanishTV ? product.prodTypeValue === "LOCLDGTL" : false) : (
              product.prodTypeValue === "MUNDO" ||
              product.prodTypeValue === "MUNDO_TOTAL"))
          ) {
            return (
              <Tile
                flowType={this.props.flowType}
                product={product}
                serviceType={serviceType}
                cloudAccStatus={cloudAccStatus}
                key={index}
                isChecked={isChecked}
                voiceTn={voiceTn}
                buildProduct={buildProduct}
                lqState={lqState}
                visitId={visitId}
                visitorId={this.props.visitorId}
                modalWindow={modalWindow}
                firstBill={firstBill}
                dispatch={dispatch}
                recommendedTV={this.props.recommendedTV}
                suppSelectedProds={this.props.suppSelectedProds}
                selectedProduct={selectedProduct}
              />
            );
          }
          /*AR tv tvSublistItems old code end*/
          if (
             (this.props?.buildProduct?.isECMNEnabled) &&
            InHomeUtils.isNotNull(product) &&
            InHomeUtils.isNotNull(product?.prodType) &&
            this.props?.toggleTVMoreOption &&
            // product?.prodTypeValue !== "ULTIMATE" &&
            product?.prodTypeValue !== "PREFERRED" &&
            product?.prodTypeValue !== "ULTIMATETESTDRIVE" &&
            product?.prodTypeValue !== "MUNDO_TOTAL" &&
            product?.prodTypeValue !== "MUNDO" &&
            product?.prodTypeValue !== "CUSTOM_GENERIC" &&
            product?.prodTypeValue !== "EXTREME" &&
            ((product?.prodTypeValue === "Spotlight" && !spotlight_selected) || product?.prodTypeValue === "Fios_Five" ||
              product?.prodTypeValue === "LOCLDGTL" || (product?.prodTypeValue === "ULTIMATE" && product?.id ==="Q2493")) // ultimate TV HD(Q2493) and The Most Fios TV 4.0(R3575) having same prodtype and prodtypevalue
          ) {
            const formattedProd = formatTVProduct(
              product,
              buildProduct?.plansPromoFragments,
              !buildProduct.mnFromApi,
              this.props?.appState,
            );
            const prod = { ...product, ...formattedProd };
            return (
              <Tile
                midniteProd={prod}
                showProdBanner={showProdBanner}
                flowType={this.props.flowType}
                product={product}
                serviceType={serviceType}
                cloudAccStatus={cloudAccStatus}
                key={index}
                isChecked={isChecked}
                voiceTn={voiceTn}
                buildProduct={buildProduct}
                lqState={lqState}
                visitId={visitId}
                visitorId={this.props.visitorId}
                modalWindow={modalWindow}
                firstBill={firstBill}
                dispatch={dispatch}
                recommendedTV={this.props.recommendedTV}
                suppSelectedProds={this.props.suppSelectedProds}
                selectedProduct={selectedProduct}
              />
            );
          }
        });

        if (lqState.isFCPflow === true && serviceType === Service.tv) {
          SublistItems = this.props.products.map((product, index) => {
           
            let isChecked =
              serviceType === Service.channel
                ? selectedProduct.indexOf(product.id) > -1
                : serviceType === Service.winBack ||
                  serviceType === Service.splOffer
                ? product.id === selectedProduct.id
                : serviceType === Service.streamDevCount
                ? product.unitCount === selectedProduct.unitCount
                : (InHomeUtils.isNotNull(product.downSpeed) &&
                    product.downSpeed === selectedProduct.downSpeed) ||
                  product.id === selectedProduct.id ||
                  product.id === selectedProduct.prodId;
            /*AR tv SublistItems old code start*/
            if (
              !(this.props?.buildProduct?.isECMNEnabled) &&
              product.prodType === "BASIC" &&
              (product.prodTypeValue === "MUNDO" ||
                (product.prodTypeValue === "Spotlight" && !spotlight_selected) ||
                product.prodTypeValue === "MUNDO_TOTAL" || (mm3Qualified ? product.prodTypeValue === "LOCLDGTL" : false))
            ) {
              return (
                <Tile
                  cart={this.props.cart}
                  flowType={this.props.flowType}
                  product={product}
                  serviceType={serviceType}
                  cloudAccStatus={cloudAccStatus}
                  key={index}
                  isChecked={isChecked}
                  voiceTn={voiceTn}
                  buildProduct={buildProduct}
                  lqState={lqState}
                  visitId={visitId}
                  visitorId={this.props.visitorId}
                  modalWindow={modalWindow}
                  firstBill={firstBill}
                  dispatch={dispatch}
                  recommendedTV={this.props.recommendedTV}
                  suppSelectedProds={this.props.suppSelectedProds}
                  selectedProduct={selectedProduct}
                />
              );
            }
            /*AR tv SublistItems old code End*/
            if (
               (this.props?.buildProduct?.isECMNEnabled) &&
              (product?.prodType === "BASIC" || product.prodType === "BASICDIFF") &&
              product?.prodTypeValue !== "ULTIMATE" &&
              product?.prodTypeValue !== "PREFERRED" &&
              product?.prodTypeValue !== "ULTIMATETESTDRIVE" &&
              product?.prodTypeValue !== "MUNDO_TOTAL" &&
              product?.prodTypeValue !== "MUNDO" &&
              ((product?.prodTypeValue === "Spotlight" && !spotlight_selected) || product?.prodTypeValue === "Fios_Five" ||
                product?.prodTypeValue === "LOCLDGTL")
            ) {
              const formattedProd = formatTVProduct(
                product,
                buildProduct?.plansPromoFragments,
                !buildProduct.mnFromApi,
                this.props?.appState,
              );
              const prod = { ...product, ...formattedProd };
              return (
                <Tile
                  midniteProd={prod}
                  showProdBanner={showProdBanner}
                  cart={this.props.cart}
                  flowType={this.props.flowType}
                  product={product}
                  serviceType={serviceType}
                  cloudAccStatus={cloudAccStatus}
                  key={index}
                  isChecked={isChecked}
                  voiceTn={voiceTn}
                  buildProduct={buildProduct}
                  lqState={lqState}
                  visitId={visitId}
                  visitorId={this.props.visitorId}
                  modalWindow={modalWindow}
                  firstBill={firstBill}
                  dispatch={dispatch}
                  recommendedTV={this.props.recommendedTV}
                  suppSelectedProds={this.props.suppSelectedProds}
                  selectedProduct={selectedProduct}
                />
              );
            }
          });
        }

      if (this.props.modalWindow.modalId !== "") {
        switch (this.props.modalWindow.modalId) {
          case ModalWindow.ids.dataHelp:
            internetLayout = <DataHelp speedCode={this.props.speedCode} closeModel={(e) => this.onCloseModal(e)}/>;
            break;

          case ModalWindow.ids.techSureHelp:
            techSureLayout = <TechSure />;
            break;

          case ModalWindow.ids.tvHelp:
            tvLayout = (<React.Fragment>
              {/* <div className="modal_header" />
                <div className="modal_content"><ChannelLineupMaster customonly='N' flowType={this.props.flowType}/></div> */}
              <ModalTitle></ModalTitle>
              <ModalBody><ChannelLineupMaster customonly='N' flowType={this.props.flowType} /></ModalBody>
              <div>
                <div style={{ textAlign: "center" }}>
                  <Button id="DETAIL" buttonText="Close" buttonStyle={"button secondary autoFit margin-horiz-tiny"} onClick={(e) => this.onCloseModal("e")} />
                </div>
              </div></React.Fragment>);

            break;
          case ModalWindow.ids.connectedAppsTVConnections:
            discoveryoverlay = <ConnectedAppsTVConnectionsOverlay togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} closeModel={(e) => this.onCloseModal(e)} TVSoundbar={TVSoundbar} showStreamTV={showStreamTV} />;
            if (this.props.lqState?.runtimeKey?.QAM === 'Y' && this.props.lqState?.lqResponse?.ontPonType !== 'BPON') {
              discoveryoverlay = <ConnectedAppsTVConnectionsOverlayQAM togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} closeModel={(e) => this.onCloseModal(e)} TVSoundbar={TVSoundbar} showStreamTV={showStreamTV} />;
            }
            break;
          case ModalWindow.ids.connectedAppsCEApps:
            discoveryoverlay = <ConnectedAppsCEAppsOverlay togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} closeModel={(e) => this.onCloseModal(e)} TVSoundbar={TVSoundbar} showStreamTV={showStreamTV} />;
            if (this.props.lqState?.runtimeKey?.QAM === 'Y' && this.props.lqState?.lqResponse?.ontPonType !== 'BPON') {
              discoveryoverlay = <ConnectedAppsCEAppsOverlayQAM togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} closeModel={(e) => this.onCloseModal(e)} TVSoundbar={TVSoundbar} showStreamTV={showStreamTV} />;
            }
            break;

          case ModalWindow.ids.helpEquip:
            tempVzdlSCData.detail = "Experience Fios TV One and experience TV at its best";
            tempVzdlSCData.events = "prodView";
            updateVzdlSCCustomEvent("winBackLoad", "pageViewOmni", "detail,events");
            equipLayout = <EquipmentLearnMore />;
            break;

          case ModalWindow.ids.customTvHelp:
            customTvLayout = <CustomTvLearnMore dispatch={this.props.dispatch} />;
            break;

          case ModalWindow.ids.listingHelp:
            listingLayout = <ListingLearnMore />;
            break;

          case ModalWindow.ids.batteryHelp:
            batteryLayout = <BatteryLearnMore />;
            break;

          case ModalWindow.ids.dctHelp:
            dctLayout = <DigitalAdapterLearnMore />;
            break;

          case ModalWindow.ids.seeDetail:
            seeDetailLayout = <SeeDetailsOverlay fcpOffer={this.props.buildProduct.fcpSeeDetails} product={this.props.products} closeOverlay={(e) => this.onCloseModal(e)} />;
            break;

          case ModalWindow.ids.addlIntrPkg:
            alldIntrPkgOverlay = <AddlIntrPackages packages={this.props.buildProduct.internationalChannel.equipments} selectedproducts={this.props.buildProduct.internationalChannel.selectedProduct} closeOverlay={(e) => this.onCloseModal(e)} visitId={this.props.visitId} appState={this.props?.appState}
              buildProduct={this.props.buildProduct} cart={this.props.cart} modalWindow={this.props.modalWindow} lqState={this.props.lqState} dispatch={this.props.dispatch} />;
            break;
          case ModalWindow.ids.internationalPlanOverlay:
            intlPlansOverlay = <InternationalPlanOverlay />
            break;

          default:
            break;
        }
      }
      if (InHomeUtils.isNotEmpty(this.props.modalWindow.modalId) && this.props.modalWindow.modalId.indexOf("DETAIL_") > -1) {
        detailLayout = <React.Fragment>
          {/* <div className="modal_header">
          <div><h5 className="margin-top-zero">Stream TV</h5></div>
          <p className="margin-top-zero">{ReactHtmlParser(this.props.buildProduct.viewDetailContent)}</p>
          <Button id="DETAIL" buttonText="Close" buttonStyle={"button secondary autoFit"} onClick={(e) => this.onCloseModal("e")} />
        </div> */}
          <ModalTitle>
            <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h5" color="black">Stream TV</Title> </ModalTitle>
          <ModalBody><p className="margin-top-zero">{ReactHtmlParser(this.props.buildProduct.viewDetailContent)}</p>
            <Button id="DETAIL" buttonText="Close" buttonStyle={"button secondary autoFit"} onClick={(e) => this.onCloseModal("e")} />
          </ModalBody>
        </React.Fragment>
      }

      if (serviceType === Service.internet) {
        const { buildProduct } = this.props;
        if (lqState.isFCPflow
          && lqState.runtimeKey
          && lqState.runtimeKey.CovidSelfInstallInternet === 'Y'
          && buildProduct
          && buildProduct.disclaimerProductsFragments
          && buildProduct.disclaimerProductsFragments.covidInternetRibbon) {
          const selfInstallMessage = buildProduct.internet.selfInstallMesssage || '';
          const showSelfInstallFor100M = lqState.runtimeKey.ShowSelfInstallFor100M && lqState.runtimeKey.ShowSelfInstallFor100M === 'Y'
          let selfInstallAvailableSpeeds = selfInstallMessage
            && this.props.products.reduce((acc, product) => {
              return selfInstallMessage.indexOf(product.id) > -1 ? acc.concat(product.name) : acc
            }, []) || [];

          // selfInstallAvailableSpeeds = selfInstallAvailableSpeeds.slice(0,2);
          const { disclaimerProductsFragments } = buildProduct;
          const { covidInternetRibbon, covidInternetRibbonAllOptions, covidInternetRibbonUpgrade, covidInternetRibbon100M } = disclaimerProductsFragments;
          let renderCovidInternetRibbon = showSelfInstallFor100M && buildProduct.emergencyNotification && buildProduct.emergencyNotification.isGPONMochaEligible ? ''
            : covidInternetRibbon && covidInternetRibbon.disclaimer
            && ReactHtmlParser(covidInternetRibbon.disclaimer)
            || <span> As a result of COVID-19 social distancing, we are offering a , <b>self-install kit</b> for </span>;
          const renderCovidInternetRibbonAllOptions = covidInternetRibbonAllOptions
            && covidInternetRibbonAllOptions.disclaimer
            && ReactHtmlParser(covidInternetRibbonAllOptions.disclaimer)
            || <b>all internet options</b>;
          const renderCovidInternetRibbonUpgrade = covidInternetRibbonUpgrade
            && covidInternetRibbonUpgrade.disclaimer
            && ReactHtmlParser(covidInternetRibbonUpgrade.disclaimer)
            || <p>You may upgrade at any time</p>;
          const renderCovidInternetRibbon100M = ReactHtmlParser(covidInternetRibbon100M
            && covidInternetRibbon100M.disclaimer
            ? covidInternetRibbon100M.disclaimer.replace("100 Mbps", selfInstallAvailableSpeeds.length ? selfInstallAvailableSpeeds.join(", ") : "100 Mbps")
            : "<span>COVID-19 Important Info: To get Fios service quickly, select 100 Mbps for a self installation option. Other speeds will be held for a future technician installation when we resume normal operations.</span>".replace("100 Mbps", selfInstallAvailableSpeeds.length ? selfInstallAvailableSpeeds.join(", ") : "100 Mbps"));
          const selfInstallOptions = selfInstallAvailableSpeeds.length
            ? showSelfInstallFor100M && buildProduct.emergencyNotification && buildProduct.emergencyNotification.isGPONMochaEligible
              ? renderCovidInternetRibbon100M
              //  :selfInstallAvailableSpeeds.length === this.props.products.length 
              //    ? renderCovidInternetRibbonAllOptions
              //    : <React.Fragment>
              //      {selfInstallAvailableSpeeds.map((speed, idx, arr) => (<b>{ speed}{ idx !== arr.length -1 ? ',': ''} </b> )) }
              //      {renderCovidInternetRibbonUpgrade }   
              //      </React.Fragment> 
              : '' : '';

          emergencySelfInstallMessage = selfInstallOptions
            ? <div>
              <div className="clear text-normal padding-top-tiny normal-weight tile-link"  >
                {renderCovidInternetRibbon}
                {/* {selfInstallOptions} */}
              </div>
            </div>
            : ''
        }
        helperMsg = <div>
          {/* PFB made optional and below div has to be commented for 04/21 ER.*/}
          {/* <div className={hoaflow ? "hide clear" : "clear clear text-normal tiny-padding-top-tiny normal-weight tile-link"}>Requires Paper-free Billing</div> */}
          <div className="hide clear">Select these products for the fastest installation time.</div>
          <div className="clear padding-top-micro"></div>
          {/* {!mm3Qualified ? <div className="clear padding-bottom-micro inline-block">
            <a className="text-black pointer tile-link" tabIndex="0" id="HELPDATA" role="button"
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              onClick={(e) => this.props.openModel(e, this.props.name)}
              title="Open modal with connection speed information"
            >Help me choose
              <span className="accordion_icon-chevron-right" aria-hidden="true"></span>
            </a>
            <ModalOverlay className="vzicon small text-black middle" template={internetLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div> : ''} */}
        </div>
        // if(lqState.isFCPflow)
        // {
        //   seeDetails= <div className="clear text-normal tiny-padding-top-tiny"><a className="text-black pointer underline tile-link" 
        //   tabIndex="0"
        //   onClick={(e) => this.seeDetailsClick("1","see")}
        //   onKeyDown={(e) => this.seeDetailsClick("1","see")}
        //   id='SEEDETAIL'
        //   title="See Details">
        //   See Details
        //   </a>
        //   <span className="normal-weight">&nbsp;about gift card and special offers.</span>
        //   <ModalOverlay className="vzicon small text-black middle" template={seeDetailLayout}  modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        //   </div>
        // }
             

      }
      else if (serviceType === Service.vRoom && !(this.props.container && (this.props.container === 'CEAPPS' || this.props.container === 'TVCONNECTIONS' || this.props.container === 'CEBUNDLE'))) {
        if (this.props.selectedProduct.prodType === Service.vRoom) {
          if (this.props.selectedProduct.quantity > 4) {
            isUnsupportMsg = true;
          } else if (InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.tv) && InHomeUtils.isNotEmpty(this.props.buildProduct.tv.vcpestbQty) && this.props.buildProduct.tv.vcpestbQty > 4) {
            isUnsupportMsg = true;
          }
        }
        channelMsg = <div className={this.props.localChannelMsg !== undefined && this.props.localChannelMsg ? "text-xlarge text-black normal-weight margin-left-micro tile-text" : "hide"}>Equipment is not needed for Local TV with cable-ready televisions.</div>
        // helperMsg = <div>
        //   <div className="clear padding-top-micro"></div>
        //   <div className="clear padding-horiz-tiny inline-block">
        //     <a className="text-black pointer tile-link"
        //       onClick={(e) => this.props.openModel(e, this.props.name)}
        //       onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
        //       tabIndex="0"
        //       id='HELPEQUIPMENT'
        //       title="Open modal with equipment details">
        //       Tell me about the equipment
        //       <span className="accordion_icon-chevron-right" aria-hidden="true"></span></a>
        //     <ModalOverlay className="vzicon small text-black middle" template={equipLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        //   </div>
        // </div>
        if (isEmergency && this.props.buildProduct && this.props.buildProduct.emergencyNotification && this.props.buildProduct.emergencyNotification.displayVroomMsg) {
          let vroomContent = "Due to the COVID-19 outbreak,  we are limiting technician installation orders to 1 set-top box. If you need additional set-top boxes, you will be able to order additional ones after your installation is complete.";
          if (this.props.lqState && InHomeUtils.isNotNull(this.props.lqState.emergencyNotification) && InHomeUtils.isNotNull(this.props.lqState.emergencyNotification.states) && this.props.lqState.emergencyNotification.states !== 'dummy value' && this.props.lqState.emergencyNotification.states["~VROOM"] && this.props.lqState.emergencyNotification.states["~VROOM"].promo) {
            vroomContent = this.props.lqState.emergencyNotification.states["~VROOM"].promo;
          }
          if (!vroomContent.includes("NOTIFICATION-SUPPRESSED")) {
            vroomNotification = <div className="tiny-margin-left-tiny margin-left-large emergency-notification margin-top-tiny margin-vert-large"><span>{vroomContent}</span></div>
          }
        }
      }
      /*else if (serviceType === Service.techSure) {
        helperMsg = <div id='TECHSURE'>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block">
            <a className="text-black pointer tile-link" 
               onClick={(e) => this.props.openModel(e, this.props.name)}
               onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
               tabIndex = "0" 
               id="HELPTECHSURE"
               title="Open modal with TechSure product details">
               Compare TechSure Products
               <span className="accordion_icon-chevron-right" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={techSureLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        </div>
      }*/
      else if (serviceType === Service.tv && lqState.isFCPflow !== true) {
        helperMsg = <div>
          <div className="columns padding-top-tiny text-black text-normal normal-weight tile-link">Plus taxes, RSN and other fees</div>

          <div id="dvCompareChl" className={(this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree") ? "hide" : "padding-horiz-micro clear"} style={{ position: "relative" }}>
            <a className="text-black pointer tile-link"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              id="HELPTV"
              tabIndex="0"
              title="Open modal with Tv plan details">
              What comes with each TV plan?
            </a>
          </div>
          <ModalOverlay className="vzicon small text-black middle" template={tvLayout} modalOverlayId="helptv-modal-overlay" modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        </div>
      }
      else if (serviceType === Service.channel) {
        if (this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.channel) && InHomeUtils.isNotNull(this.props.buildProduct.channel.equipments) && this.props.buildProduct.channel.equipments.length === 2) {
          specialofferMsg = this.getspecialOffer(this.props.flowType, this.props.buildProduct, this.props.dispatch)
          if (specialofferMsg) {
            channelMsg = <React.Fragment><div className="text-xlarge text-black normal-weight margin-left-micro tile-text">Choose 1 for $15, 2 for $25</div>
              <div className="text-normal normal-weight margin-left-micro tile-text special-offer">Limited time offer: 50% off the first 3 months on all newly added Premium Movie Channels. After 3 months, standard billing rates will apply.</div></React.Fragment>
          }
          else {
            channelMsg = <div className="text-xlarge text-black normal-weight margin-left-micro tile-text">Choose 1 for $15, 2 for $25</div>
          }
        }
        else {
          specialofferMsg = this.getspecialOffer(this.props.flowType, this.props.buildProduct, this.props.dispatch)
          if (specialofferMsg) {
            channelMsg = <React.Fragment><div className="text-xlarge text-black normal-weight margin-left-micro tile-text">Choose 1 for $15, 2 for $25, 3 for $30, 4 or 5 for $40</div>
              <div className="text-normal normal-weight margin-left-micro tile-text special-offer">Limited time offer: 50% off the first 3 months on all newly added Premium Movie Channels. After 3 months, standard billing rates will apply.</div></React.Fragment>
          }
          else {
            channelMsg = <div className="text-xlarge text-black normal-weight margin-left-micro tile-text">Choose 1 for $15, 2 for $25, 3 for $30, 4 or 5 for $40</div>
          }
        }
      }
      else if (serviceType === Service.winBack) {
        channelMsg = <div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">
          Your service includes a new phone number.<br /> Would you like us to check if you current phone number will work with your new service?</div>
      }
      else if (serviceType === Service.battery) {
        channelMsg = <React.Fragment><div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">
          Your phone service requires electricity in order to make or receive calls,
          <div aria-expanded={this.props.toggle ? true : false} className={this.props.toggle ? "battery_More_Txt small-text-large tile-text " : "hide small-text-large "}>
            including calls to 911.  If your power goes out, a backup power device with batteries can support up to 8 hours of basic phone service.</div>
          <span className="bold text-xlarge small-text-large text-black bold tile-text moreorlessLink" aria-expanded={this.props.toggle ? true : false} tabIndex="0" role="button" onKeyDown={(e) => this.handleKeyDownDetails(e)} onClick={this.props.showMoreClick}>{this.props.toggle ? " ...less" : " ...more"}</span></div>
          <div className="text-xlarge small-text-large text-black bold padding-vert-tiny bbuques tile-text">Would you like a backup power device?</div></React.Fragment>
        helperMsg = <div>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block tile-link">
            <a className="text-black pointer"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              tabIndex="0"
              id="HELPBATTERY"
              title="Open modal with PowerReserve details">Tell me about PowerReserve
              <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={batteryLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        </div>
      }
      else if(serviceType === Service.splOffer && this.props?.flowType === 'SUPP') {
        if((this.props?.BFxBoxSeriesInProfile &&  this.props?.BFxBoxSeriesInProfile?.length > 0) || (this.props?.BFxBoxBundleInProfile &&  this.props?.BFxBoxBundleInProfile?.length > 0) || (this.props?.BFNetmaxInProfile &&  this.props?.BFNetmaxInProfile?.length > 0)){
          let specailBonusOffertxt = this.getSpecialBonusOffer(this.props.flowType, this.props.buildProduct)
        channelMsg = specailBonusOffertxt ? <React.Fragment>
          <div className
          ='specailofferbadge' style={{marginLeft: "10px"}}>
            <p className="specailofferbadgeText suppsplofferbagetext">{`Cyber Monday 1-day offer: Switch your offer below to Xbox Gaming Bundle or Netflix & Max to receive `}</p>
            <div className="specailofferbadgeText suppsplofferbagetextoffertext">{` ${specailBonusOffertxt?.replace('Console On Us and','and Bonus:')}`}</div>
          </div></React.Fragment> : '';
        } else {
          let specailBonusOffertxt = this.getSpecialBonusOffer(this.props.flowType, this.props.buildProduct)
        let concatenationPural = this.props.products.length > 2 ? 'all' :this.props.products.length > 1 ? 'both' :'';
      
        channelMsg = specailBonusOffertxt ? <React.Fragment>
          <div className='specailofferbadge' style={{marginLeft: "10px"}}>
          <p className="specailofferbadgeText">{`Limited time offer: ${specailBonusOffertxt?.replace('Console On Us and','and Bonus:')} ${(specailBonusOffertxt.indexOf(' and ') > -1) ? 'are' : 'is'} included with ${concatenationPural} the offer choices.`}</p>
            {/* // ${concatenationPural} */}
          
          </div></React.Fragment> : '';
        }
        
      }
      else if (serviceType === Service.dct) {
        channelMsg = <React.Fragment><div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">
          This is the most basic way to watch Fios TV. You won’t have all the features
          <div className={this.props.toggle ? "battery_More_Txt small-text-large tile-text " : "hide small-text-large "}>
            <span> of a set top box, like HD, video on demand, recording, and the full media guide, but you’ll be able to see your favorite channels.</span></div>
          <span className="bold text-hyperlink" onClick={this.props.showMoreClick}>{this.props.toggle ? " ...less" : " ...more"}</span></div>
          <div className="text-xlarge small-text-large text-black bold padding-vert-tiny bbuques tile-text">One digital adapter is included with your Fios TV service at no charge. Would you like a digital adapter?</div></React.Fragment>
        helperMsg = <div>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block tile-link">
            <a className="text-black pointer"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              tabIndex="0"
              id="HELPDCT"
              title="Open modal with Digital Adapter details">
              Tell me about the Digital Adapter
              <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={dctLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        </div>
      }
      else if (serviceType === Service.batteryshipment) {
        channelMsg = <React.Fragment><div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">
          Your Voice Backup PowerReserve will be shipped separately after your service.</div>
          <div className="text-xlarge small-text-large text-black bold padding-vert-tiny bbuques tile-text">How would you like us to send it?</div>
          {(this.props.buildProduct?.backup?.shipment?.selectedProduct === null && Array.isArray(this.props.buildProduct?.backup?.shipment?.shipmentProducts) && this.props.buildProduct?.backup?.shipment?.shipmentProducts?.length > 0) && (
            <div className="padding-vert-tiny tile-text" style={{ color: "rgb(196, 73, 4)", paddingRight: "5px", fontSize: "1rem", fontWeight: "400", lineHeight: "1.25rem" }}>Required</div>
          )}
        </React.Fragment>
      }
      else if (serviceType === Service.customTV) {
        channelMsg = <div className="text-xlarge text-black normal-weight margin-left-micro tile-text">Choose a package with the types of programming you watch. Local and regional channels are included.</div>
        helperMsg = <div>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block tile-link">
            <a className="text-black pointer"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              tabIndex="0"
              id="HELPCUSTOMTV"
              title="Open modal with package details">Help me choose
              <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={customTvLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        </div>
      }
      else if (serviceType === Service.flashOffer && this.props.lqState?.runtimeKey?.EnableBlackFridayOffers === 'N') {
        helperMsg = <div id='FLASHOFFERDISC'>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block">
            <span>Order must be submitted by November 29 midnight EST to receive your Black Friday bonus.</span><br />
          </div>
        </div>
      }
      else if (serviceType === Service.recording) {
        if (this.props.selectedProduct.prodTypeVal === "PM-DVR") {
          isUnsupportMsg = true;
        }
      }
      else if (serviceType === Service.intrnlChnl) {
        channelMsg = <React.Fragment><div className="text-xlarge text-black text-heading margin-left-micro tile-text margin-top-micro">Spanish Packages</div>
          <div className="text-normal normal-weight margin-left-micro tile-text">Choose a region that meets your needs for $10, stack additional regions for $5 each.</div></React.Fragment>
        helperMsg = <div>
          <div className="clear padding-top-micro"></div>
          <div className="clear padding-horiz-tiny inline-block tile-link">
            <div className="text-normal normal-weight margin-left-micro tile-text">Can't find what you're looking for?</div>
            <a className="text-black pointer"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              tabIndex="0"
              id="ADDLINTRPKG"
              title="Open modal with Additional International Package details">Additional International Packages
              <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={alldIntrPkgOverlay} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        </div>
      }
      else if ((serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle) && this.props.container && this.props.container === 'CEBUNDLE') {
        channelMsg = <div><div className="text-xlarge text-black normal-weight margin-left-micro tile-text"><b>Now watch Fios TV on your streaming  device.</b></div><p className="text-large text-black normal-weight margin-left-micro margin-right-macro tile-text">The Fios TV Home app allows you to use your Apple TV or Fire TV to watch Fios TV.</p></div>
      }
      else if (serviceType === Service.dummyvRoom) {
        channelMsg = <div><div className="text-medium text-black normal-weight margin-left-micro tile-text"><b>Step 1: Select a number of Verizon set-top boxes.</b></div><p className="text-xlarge text-black normal-weight margin-left-micro margin-right-macro tile-text">Of your {this.props.buildProduct.vRoom && this.props.buildProduct.vRoom.unitCount ? this.props.buildProduct.vRoom.unitCount : ''} TVs, first you'll select how many will use Verizon set-top boxes.
          <br />For any remaining TVs, you'll select a use-your-own streaming device option in step 2.</p></div>
        //helperMsg=<div>{((this.props.container == "TVCONNECTIONS") && (this.props.buildProduct.vRoom && this.props.buildProduct.vRoom.unitCount && this.props.buildProduct.tvConnections &&(this.props.buildProduct.tvConnections.unitCount < this.props.buildProduct.vRoom.unitCount)))?"yes":"no"}</div>
      }
      else if ((serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle) && this.props.container && this.props.container === 'TVCONNECTIONS') {
        channelMsg = <div><div className="text-xlarge text-black normal-weight margin-left-micro tile-text"><b>Step 2: Select a use-your-own streaming device option for your remaining TVs. ({this.props.buildProduct.vRoom && this.props.buildProduct.vRoom.unitCount ? this.props.buildProduct.vRoom.unitCount : ''} total). </b></div><p className="text-xlarge text-black normal-weight margin-left-micro margin-right-macro tile-text">You can watch Fios TV on your streaming device with the Fios TV Home app. <br />Additional connections can be added by selecting the Unlimited option. </p></div>
      }

      if (serviceType === Service.tv && lqState.isFCPflow === true) {
        tvListItems = listItems?.filter(item => item);
        tvMoreOptions = SublistItems?.filter(item => item);
        tvStreamServlist = streamServlist?.filter(item => item);
        mobileTvAll = [...tvListItems, ...tvStreamServlist, ...tvMoreOptions]
        mobileSpanish = [...tvListItems]
        listItems = (
          <React.Fragment>
            {listItems}
            {((this.props?.buildProduct?.isECMNEnabled) && !this?.props?.buildProduct?.tv?.spanishTV) ? streamServlist : ""}
            <div
              className={
                this.props.toggleTVMoreOption
                  ? (this.props?.buildProduct?.isECMNEnabled) ? "accordionMNTile columns padding-left-zero" :"accordionTile columns padding-left-zero" : "hide"
              }
              aria-hidden="false"
            >

              {!(this.props?.buildProduct?.isECMNEnabled) && SublistItems}
              {/* {( (this.props?.buildProduct?.isECMNEnabled) && !this?.props?.buildProduct?.tv?.spanishTV) ? streamServlist : ""} */}
              {((this.props?.buildProduct?.isECMNEnabled) && !this?.props?.buildProduct?.tv?.spanishTV) ? SublistItems : ""}
            </div>
          </React.Fragment>
        );

        !suppHasSlingTV
          ? (fcphelperMsg = (
              <React.Fragment>
                
                 <p 
                 className="plusTaxesEquipment"
                 style={{'color':"#6f7171",
                 'padding-top' : "20px"
                }}>* Plus taxes and equipment charges.<br></br><sup>1</sup> {`Plus taxes. ${this.props.lqState?.runtimeKey?.enableYTTV === 'Y' ? 'New YouTube TV subscribers only. Regular rates apply after 1 year.' : ''}`}</p>
                 
                <a
                  className="columns padding-top-tiny text-black pointer SeemoreRskn"
                  onClick={this.props.showMoreTvOption}
                  onKeyDown={(e) => this.handleKeyDownTvOption(e)}
                  tabIndex="0"
                  id="MORETVOPT"
                  role="button"
                  title={
                    this.props.toggleTVMoreOption
                      ? "Click Here for Less TV Options"
                      : "Click Here for More TV Options"
                  }
                >
                  {!this?.props?.buildProduct?.tv?.spanishTV && !this.props?.isMobileView &&
                    (this.props.toggleTVMoreOption 
                      ? (this.props.buildProduct?.isECMNEnabled ? "Less options" : 'See less options') 
                      : (this.props.build?.isECMNEnabled ? "More options" : 'See more options'))}
                      
                  {/* <span className={`${this.props.toggleTVMoreOption ? 'vzicon smallChevron cart-icon icon-chevron-up' : 'vzicon smallChevron cart-icon icon-chevron-down'}`} style={{verticalAlign: 'top', marginLeft: '8px'}} aria-hidden="true"></span> */}
                </a>
               
                {/* <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a> */}
                {/* <div className="columns padding-top-tiny text-black">4 Streams Included with all TV packages.</div> */}
              </React.Fragment>
            ))
          : "";
        tvSublistItems = "";
        // seeDetails= <div className="clear text-normal tiny-padding-top-tiny"><a className="text-black pointer underline tile-link"
        //       tabIndex="0"
        //       onClick={(e) => this.seeDetailsClick("1","see")}
        //       onKeyDown={(e) => this.seeDetailsClick("1","see")}
        //       id='SEEDETAIL'
        //       title="See Details">
        //       See Details
        //       </a>
        //       <span className="normal-weight">&nbsp;about gift card and special offers.</span>
        //       <ModalOverlay className="vzicon small text-black middle" template={seeDetailLayout}  modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        //       </div>
      }
      if (serviceType === Service.tv && !lqState.isFCPflow) {
        !suppHasSlingTV ? moreOptLink = <React.Fragment>
          <a className="columns padding-top-tiny text-black pointer"
            onClick={this.props.showMoreTvOption}
            onKeyDown={(e) => this.handleKeyDownTvOption(e)}
            tabIndex="0"
            id="MORETVOPT"
            role="button"
            title={this.props.toggleTVMoreOption ? "Click Here for Less TV Options" : "Click Here for More TV Options"}>{this.props.toggleTVMoreOption ? "Less options" : "More options"}
            <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
        </React.Fragment> : ""
      }
      let voice_Remote_Image = images.voiceRemoteImage;
      let acc_Box_Image = images.accBoxImage;
      if (this.props.lqState?.runtimeKey?.QAM === 'Y' && this.props.lqState?.lqResponse?.ontPonType !== 'BPON') {
        voice_Remote_Image = images.voiceRemoteImageQAM;
        acc_Box_Image = images.accBoxImageQAM;
      }
      if (serviceType === Service.router || serviceType === Service.customRouter) {
        if (isCHR) {
          // tileImg = <img src={ChrImage} style={{height : '325px', width : '25%'}} alt="" className="accordion-background_images show-for-large-only" />
          tileImg = "";
        }
        else if (isBHRx) {
          tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.bhrxImage} alt="" className="accordion-background_images show-for-large-only" /></Suspense>
        }
        else {
          tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.accRouterImage} alt="" className="accordion-background_images show-for-large-only" /></Suspense>
        }

      }
      else if (serviceType === Service.tv && !mm3Qualified) {
        tileImg = lqState.isFCPflow ? <Suspense fallback={<div>loading...</div>}><LazyImage src={voice_Remote_Image} alt="" className="accordion-background_images voice-remote show-for-large-only accordion-background_remote" /></Suspense> : <Suspense fallback={<div>loading...</div>}><LazyImage src={acc_Box_Image} alt="TV Remote" className="accordion-background_images tv-remote show-for-large-only accordion-background_remote" /></Suspense>
      }
      else if (serviceType === Service.dummyvRoom || (serviceType === Service.vRoom && this.props.container && this.props.container === 'CEAPPS')) {
        tileImg = '';
      }
      else if (serviceType === Service.vRoom && lqState.isFCPflow) {
        tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={voice_Remote_Image} alt="" id="ffVRoom" className="accordion-background_images voice-remote show-for-large-only accordion-background_remote" /></Suspense>
      } else if (serviceType === Service.vRoom || serviceType === Service.recording || serviceType === Service.customTV) {
        // tileImg = <img src={acc_Box_Image} alt="" className="accordion-background_images tv-remote show-for-large-only accordion-background_remote" />
        tileImg = "";
      } else if (serviceType === Service.techSure) {
        //tileImg = <img src={techSureImage} alt="Internet Router" className="accordion-background_images show-for-large-only" />
      } else if (serviceType === Service.streamServ || (!lqState.isFCPflow && serviceType === Service.streamDev) || serviceType === Service.streamDevCountResume || serviceType === Service.streamDevCount) {
        tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.streamingImage} alt="Internet Router" className="accordion-background_images show-for-large-only" /></Suspense>
      }
      else if (serviceType === Service.voice || serviceType === Service.listing || serviceType === Service.winBack || serviceType === Service.intlPlans) {
        tileImg = ""
        if (serviceType === Service.listing) {
          channelMsg = <div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">Would you like your phone number to appear in the directory?</div>
        }
        else if (serviceType === Service.intlPlans) {
          channelMsg = <div className="small-text-large text-black bold padding-vert-tiny tile-text">Do you need to make calls to more than one country or destination? Add a Verizon<br />World Plan.
            <a className="text-black pointer"
              onClick={(e) => this.props.openModel(e, this.props.name)}
              onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
              tabIndex="0"
              id="INTLPLANOVERLAY"
              title="Open modal with international plan details"> View included countries and destinations.
              <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
            <ModalOverlay className="vzicon small text-black middle" template={intlPlansOverlay} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
          </div>
        }
      }
      else if (serviceType === Service.channel) {
        tileImg = <Suspense fallback={<div>loading...</div>}><LazyImage src={images.premiumChannelImage} alt="TV Chennal" className="accordion-background_images p-100 show-for-large-only" /></Suspense>
      }
    }
    let prodSectionID = serviceType + "_SECTION";
    let divAccordiontileClassName =
    this.props?.buildProduct?.isECMNEnabled ? "accordionMNTile":"accordionTile " +
      serviceType +
      " " +
      `${!mm3Qualified ? "classicFlow " : "mm3Flow "}` +
      " ";
    if (serviceType === Service.recording) {
      if (this.props.buildProduct && this.props.buildProduct.vRoom && InHomeUtils.isNotNull(this.props.buildProduct.vRoom.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProduct.vRoom.selectedProduct.id) && this.props.buildProduct.vRoom.selectedProduct.id === "NOVROOM"
        && this.props.buildProduct && this.props.buildProduct.recording && InHomeUtils.isNotNull(this.props.buildProduct.recording.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProduct.recording.selectedProduct.id) && this.props.buildProduct.recording.selectedProduct.id === "NORECORD")
        divAccordiontileClassName = "accordionTile disabled";
    }
    if (serviceType === Service.streamDevCount) {
      headingMsg = <p className="margin-top-zero bold medium-padding-right-small">Please tell us how many you need?</p>
    }
    // Changes for PR00032100  HBO Only
    if (serviceType === Service.channel && this.props.buildProduct && InHomeUtils.isNotNull(this.props.buildProduct.hboUnSupportedNotificationInfo) && InHomeUtils.isNotNull(this.props.buildProduct.hboUnSupportedNotificationInfo.showNotification) && InHomeUtils.isNotEmpty(this.props.buildProduct.hboUnSupportedNotificationInfo.showNotification) && this.props.buildProduct.hboUnSupportedNotificationInfo.showNotification == true) {
      hboUnSupportMsg = <div className={this.props.buildProduct.hboUnSupportedNotificationInfo.showNotification ? "w_message bg-brand-4 padding-all-tiny text-white" : "hide"} id="RemoveCOAHeaderText">
        <div className="clearfix">
          <div className="left p-auto">
            <span className="vzicon icon-alert middle margin-right-micro margin-bottom-zero block" aria-hidden="true"></span>
          </div>
          <div className="inline-block tiny-p-80 medium-p-auto suppalert" tabIndex="0" style={{ fontWeight: 'normal', fontStyle: 'normal', fontSize: '.875rem' }}>HBO is already in your cart and is not sold online.  You must
            <Button id="unSupportedDetails" buttonText="remove" disableButton={false} buttonStyle={"text-white underline bold link-btn"} onClick={this.onNonSupportedLinkClick} />HBO from your cart before you can add Max.
          </div>
        </div>
      </div>
    }
    if (this.props.intlCalling) {
      let tile = "";
      let noneIntlCallingPlanText = "";
      let value = this.state.value;
      if (value === '' && InHomeUtils.isNotNull(this.props.buildProduct.intlCalling.selectedProduct)) {
        value = this.props.buildProduct.intlCalling.selectedProduct.countryName;
      }
      let menuStyle = {
        borderWidth: '1px',
        borderColor: '#ccc',
        borderStyle: 'solid',
        overflow: 'auto',
        maxHeight: '6rem',
        borderRadius: '3px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        background: '#aaaaaa',
        fontSize: 'small',
        paddingLeft: '2px',
        position: 'absolute',
        top: '62px',
        left: '20px',
        zIndex: '1'
      }
      let wrapperStyle = { width: "30%", margin: "10px 0px 0px 20px" };
      if (this.props.modalWindow.modalId !== "" && this.props.modalWindow.modalId === ModalWindow.ids.internationalCallingOverlay)
        intCallingOverlay = <InternationalCallingOVerlay intlCallingProducts={this.props.intlCallingProducts} />
      if (InHomeUtils.isNotEmpty(this.props.selectedProduct)) {
        if (this.props.selectedProduct.countryName === "None at this time") {
          noneIntlCallingPlanText = <div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">You have chosen not to include this feature at this time.You can always add it later. </div>
        }
        else {
          let  product = {
            "name": this.props.selectedProduct.countryName,
            "displayPrice": "Included",
            "footer":"label",
            "price":"Included",
            "equipPromo": [
              this.props.selectedProduct.usageCap+'/mo.included'
            ],
        }
    const prod = { ...product,...this.props.selectedProduct };
          tile = (
            <Tile
              midniteProd={prod}
              showProdBanner={showProdBanner}
              flowType={this.props.flowType}
              product={this.props.selectedProduct}
              isChecked={true}
              buildProduct={buildProduct}
              lqState={lqState}
              serviceType={Service.intrnlChnlPlan}
              visitId={visitId}
              visitorId={this.props.visitorId}
              modalWindow={modalWindow}
              firstBill={firstBill}
              dispatch={dispatch}
              recommendedTV={this.props.recommendedTV}
              suppSelectedProds={this.props.suppSelectedProds}
              selectedProduct={this.props.selectedProduct}
            />
          );
          // tile = <Tile flowType={this.props.flowType} product={this.props.selectedProduct} isChecked={true} buildProduct={buildProduct} lqState={lqState} serviceType={Service.intrnlChnlPlan}
          //   visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} recommendedTV={this.props.recommendedTV} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={this.props.selectedProduct} />
        }
      }
      channelMsg = <React.Fragment>
        {/* <img src='' alt="Voice" className="accordion-background_fcp_images accordion-background_phone-small show-for-large-only" /> */}
        <div className="text-xlarge small-text-large text-black bold padding-vert-tiny tile-text">Calls to one country or destination are included. Enter and select your choice or <br />"None at this time" if you don't want this feature at this time.</div>
        <label for="intlcalling-autocomplete" className="text-xlarge text-black normal-weight padding-vert-tiny tile-text">Enter & select a country or destination</label>
        <div className="row" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
          <AutoComplete
            open={value.length > 0 && isChanged}
            getItemValue={item => item.countryName}
            items={this.state.autocompleteData || []}
            value={value || ''}
            onChange={this.onChange}
            onSelect={this.onSelect}
            menuStyle={menuStyle}
            
            //inputProps={this.props.buildProduct.intlCalling.domesticCountry && this.props.buildProduct.intlCalling.domesticCountry != null ? { id: 'intlcalling-autocomplete', class: 'margin-bottom-zero error-input' } : { id: 'intlcalling-autocomplete', class: ' margin-bottom-zero' }}
            inputProps={{
              id:'intlcalling-autocomplete',
              "aria-owns":'results',
              "aria-activedescendant":'selectedOption',
              "aria-labelledby":'selectedOption',
              style: { marginBottom: 45,fontSize:'1rem'},
              className: "searchInput channel-list-auto-search",
              ref: 'channel-list-auto-search',
            }}
            renderMenu= {(items,value,style)=>{
              return <ul id='results' role='listbox' style={{...style,...menuStyle,margin:'0',listStyleType:'none' } } children={items}/>
            }}
            renderItem={(item, isHighlighted) => (
              <li
              tabIndex='-1'
                className={`item ${isHighlighted ? 'item-highlighted mnmIntlListBackground' : ''}`}
                key={item.abbr}
                id={isHighlighted?"selectedOption":""}
                role='option'
                data-item-value= {item.countryName}
                item={JSON.stringify(item)}
                aria-selected={isHighlighted ? "true" : "false"}
                style={{
                  background: isHighlighted ? "#f6f6f6" : "white",
                  zIndex: "10",
                  'borderLeft': '0.175rem solid ',
                  'borderLeftColor': isHighlighted ? '#cd040b' : 'transparent',
                  paddingLeft: "4px"
                }}>
                {item.countryName} {''} {item.usageCap}
              </li>
            )}
            wrapperStyle={wrapperStyle}
          />
          {this.props.buildProduct.intlCalling.domesticCountry && <div class='svg_border' style={{ backgroundColor: 'white', borderColor: '#ed7000 #ed7000 #ed7000  white', margin: '10px 0px 0px 0px', height: '3.2em' }}>
            {<svg data="[object Object]" style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center' }} aria-label="error icon" aria-hidden="false" tabindex="-1" viewBox="0 0 24 24" focusable="false" class="StyledSVG-oulxgz-0 svg_bidmh"><g><rect stroke="none" fill="#000000" x="11" y="16.03" width="2" height="1.98"></rect><rect vector-effect="non-scaling-stroke" stroke="#000000" stroke-width="1" fill="none" x="4.34" y="4.34" rx="2" transform="translate(-4.97 12) rotate(-45)" width="15.31" height="15.31"></rect><polygon stroke="none" fill="#000000" points="12.33 14.04 11.66 14.04 11 10.94 11 7.02 12.99 7.02 12.99 10.94 12.33 14.04"></polygon></g></svg>}
          </div>}
        </div>
        {noneIntlCallingPlanText}
        {this.props.buildProduct.intlCalling.domesticCountry &&
          <div className="text-normal text-black normal-weight margin-left-micro tile-text">This location is considered domestic and doesn't <br /> count as International.Choose a different location.</div>}
        <div className="text-normal text-black normal-weight margin-left-micro tile-text">Canada, Puerto Rico, US Virgin Islands, Guam and American Samoa aren't in the list because calls to those <br />
          locations are considered domestic with no extra charges.
          <a className="text-black pointer"
            onClick={(e) => this.props.openModel(e, this.props.name)}
            onKeyDown={(e) => this.handleKeyDown(e, this.props.name)}
            tabIndex="0"
            id="INTLCALLINGOVERLAY"
            title="Open modal with international options details"> View full list of international options.
            <span className="vzicon accordion_icon-chevron-right accordion-icon" aria-hidden="true"></span></a>
          <ModalOverlay className="vzicon small text-black middle" template={intCallingOverlay} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        </div>
        {tile}
      </React.Fragment>
    }
    if(this.props.emergServ){
      listItems = ''
      channelMsg =<React.Fragment> 
        <div>
          <div className="columns text-normal text-black clear padding-top-medium padding-bottom-small padding-vert-tiny margin-bottom">
            Will this line be used to connect a fire alarm system to a central monitoring station?
          </div>
          <div className='columns'>
          <div className="text-normal normal-weight margin-left-micro tile-text">You have the option to receive email and/or SMS text message notifications when (1) commercial power to your equipment is lost, and (2) when your backup power has expired. IMPORTANT: Notification of the expiration of backup power requires a Verizon-provided Battery Backup Unit or Power Reserve.</div>
            {/* <Tile flowType={this.props.flowType} product={this.props.products[0]} isChecked={(this.props.selectedProduct && this.props.selectedProduct.value === 'yes') ? true : false} buildProduct={buildProduct} lqState={lqState} serviceType={Service.emergencyServices}
            visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={this.props.buildProduct.emergencyServices.selectedProduct} />
            
            <Tile flowType={this.props.flowType} product={this.props.products[1]} isChecked={(this.props.selectedProduct && this.props.selectedProduct.value === 'no') ? true : false} buildProduct={buildProduct} lqState={lqState} serviceType={Service.emergencyServices}
            visitId={visitId} visitorId={this.props.visitorId} modalWindow={modalWindow} firstBill={firstBill} dispatch={dispatch} suppSelectedProds={this.props.suppSelectedProds} selectedProduct={this.props.buildProduct.emergencyServices.selectedProduct} /> */}
                        <div className={`${'yesNoUseThisLine'}`}>
              {(this.props?.buildProduct?.isECMNEnabled)  ? 
            <div className="vdsRadioConflictWithVZRF" style={{marginLeft:15}}> 
               <RadioButtonGroup
              onChange={(e) => this.selectRadio(e)}
              error={false}
              value={this.props?.buildProduct?.emergencyServices?.selectedProduct?.value}
              data={[
                {
                  name: 'group',
                  value: 'yes',
                  ariaLabel: 'Yes, I would use this line.',
                  disabled: false,
                  children: ReactHtmlParser('<span class="labelForEmergencyService"> Yes, I would use this line.</span>')
                },
                {
                  name: 'group',
                  value: 'no',
                  ariaLabel: "No, don't use this line.",
                  children: ReactHtmlParser('<span class="labelForEmergencyService">No, don\'t use this line.</span>')
                }
              ]}
              flowType={this.props.flowType}
          product={this.props.products[0]}
          // isChecked={
          //   this.props.selectedProduct &&
          //   this.props.selectedProduct.value === "yes"
          //     ? true
          //     : false
          // }
          buildProduct={buildProduct}
          lqState={lqState}
          serviceType={Service.emergencyServices}
          visitId={visitId}
          visitorId={this.props.visitorId}
          modalWindow={modalWindow}
          firstBill={firstBill}
          dispatch={dispatch}
          suppSelectedProds={this.props.suppSelectedProds}
          selectedProduct={
            this.props.buildProduct.emergencyServices.selectedProduct
          }
            />

            </div> :  <><Tile
          flowType={this.props.flowType}
          product={this.props.products[0]}
          isChecked={
            this.props.selectedProduct &&
            this.props.selectedProduct.value === "yes"
              ? true
              : false
          }
          buildProduct={buildProduct}
          lqState={lqState}
          serviceType={Service.emergencyServices}
          visitId={visitId}
          visitorId={this.props.visitorId}
          modalWindow={modalWindow}
          firstBill={firstBill}
          dispatch={dispatch}
          suppSelectedProds={this.props.suppSelectedProds}
          selectedProduct={
            this.props.buildProduct.emergencyServices.selectedProduct
          }
        />

        <Tile
          flowType={this.props.flowType}
          product={this.props.products[1]}
          isChecked={
            this.props.selectedProduct &&
            this.props.selectedProduct.value === "no"
              ? true
              : false
          }
          buildProduct={buildProduct}
          lqState={lqState}
          serviceType={Service.emergencyServices}
          visitId={visitId}
          visitorId={this.props.visitorId}
          modalWindow={modalWindow}
          firstBill={firstBill}
          dispatch={dispatch}
          suppSelectedProds={this.props.suppSelectedProds}
          selectedProduct={
            this.props.buildProduct.emergencyServices.selectedProduct
          }
        /> </> 
      }

                 
              </div>
            </div>
            {(this.props?.selectedProduct?.value !== 'no') &&
                <div>
                  <div className="columns text-normal text-black clear padding-top-medium padding-bottom-small margin-bottom">
                    Please confirm a preferred method to notify you:
                  </div>
                  <div className='columns padding-bottom-small margin-bottom'>
                    <form name="submit">
                      <input type="radio" name="emrgServtextMessage" data-track= {dataTrack("link","notify-text")} value='text' checked={this.props.buildProduct.emergencyServices.notificationMethod==='text'} onChange={this.handleEmrgServRadio} id="emrgServtextMessage" className="" />
                      <label for="emrgServtextMessage" className='padding-right-medium text-normal normal-weight'>Text Message</label>                  
                      <input type="radio" name="emrgServEmail" data-track= {dataTrack("link","notify-email")} value='email' checked={this.props.buildProduct.emergencyServices.notificationMethod==='email'} onChange={this.handleEmrgServRadio} id="emrgServEmail" className="" />
                      <label for="emrgServEmail" className='padding-right-medium text-normal normal-weight'>Email</label>                    
                      <input type="radio" name="emrgServBoth" data-track= {dataTrack("link","notify-both")} value='both' checked={this.props.buildProduct.emergencyServices.notificationMethod==='both'} onChange={this.handleEmrgServRadio} id="emrgServBoth" className="" />
                      <label for="emrgServBoth" className='padding-right-medium text-normal normal-weight'>Both</label>                      
                      <input type="radio" name="emrgServNone" data-track= {dataTrack("link","notify-none")} value='' checked={this.props.buildProduct.emergencyServices.notificationMethod===''} onChange={this.handleEmrgServRadio} id="emrgServNone" className="" />
                      <label for="emrgServNone" className='padding-right-medium text-normal normal-weight'>None</label>
                    </form>
                  </div>
                  <br/>
                  <div className='columns'>
                  {(this.props.buildProduct.emergencyServices.notificationMethod==='text' || this.props.buildProduct.emergencyServices.notificationMethod==='both')&&
                  <div className=''>
                    <p className='row text-small'>Mobile phone number</p>
                    <PhoneNumber  
                      updatePhoneNumberState={(id, value) => this.onMobileInputChangeEmerg(id, value)}
                      hideStar = {true}
                      valuePh1 = {this.props.emergencyServicesMobile.value}
                      tnErr={!this.props.emergencyServicesMobile.mobileValid}
                      vds={true}
                      label="" 
                       />
                       <br/>
                  </div>
                  
                  }
                  {(this.props.buildProduct.emergencyServices.notificationMethod==='email' || this.props.buildProduct.emergencyServices.notificationMethod==='both')&&
                  <div className='text-small'>
                    <p className='row text-small'>Email</p>
                    <Email  className="notificationEmergServInput"
                      id="emailaddressEmergServ"
                      label=""
                      value = {this.props.emergencyServicesEmail.value}
                      placeholder="Mymail@email.com"
                      hideStar = {true}
                      vds={true}
                      updateEmail={(data) => this.onEmailInputChangeEmerg(data)}
                      emailErr={!this.props.emergencyServicesEmail.emailValid}/>

                  </div>
                  }
                  </div>
                </div>
            }
        </div>
        
      </React.Fragment>
      
    }

    if (isUnsupportMsg) {
      unsupportMsg = <div class="w_message bg-brand-4 padding-all-tiny"><p class="bold ">
        <span class="vzicon icon-info padding-right-tiny middle" aria-hidden="true"></span>
        <span class="inline-block tiny-p-80 medium-p-auto suppalert">Some of your selections are not sold online. Any changes will require new selections</span>
      </p></div>
    }
    if (serviceType === Service.dummyvRoom) {
      discoveryCheck = <ModalOverlay className="vzicon small text-black middle" template={discoveryoverlay} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
      discoverytitle = "What's the difference between Verizon set-top boxes and a use-your-own streaming device?";
      discoverySubtitle = "";
      notificationClassname = '';
      disoveryCheck = <ModalOverlay template={discoveryoverlay} className="vzicon small text-black middle" modalWindow={this.props.modalWindow} dispatch={this.props.dispatch} />
      buttonData = [
        {
          id: "CETVCONNECTIONS",
          children: "Find out",
          onClick: (e) => this.props.openModel(e, disoveryCheck)
        }
      ]
    }
    else if (!mm3Qualified && (serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle) && this.props.container && this.props.container === "CEBUNDLE") {
      discoveryCheck = <ModalOverlay className="vzicon small text-black middle" template={discoveryoverlay} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
      discoverytitle = " Do you have a compatible use-your-own streaming device?";
      discoverySubtitle = "";
      notificationClassname = '';
      disoveryCheck = <ModalOverlay template={discoveryoverlay} className="vzicon small text-black middle" modalWindow={this.props.modalWindow} dispatch={this.props.dispatch} />
      buttonData = [
        {
          id: "CECEAPPS",
          children: "Find out",
          onClick: (e) => this.props.openModel(e, disoveryCheck)
        }
      ]
    }

    if (InHomeUtils.isNotEmpty(this.props.notification)) {
      let notificationDetails = this.props.notification;
      notificationType = InHomeUtils.isNotEmpty(notificationDetails.notificationType) ? notificationDetails.notificationType : notificationType;
      discoverytitle = InHomeUtils.isNotEmpty(notificationDetails.title) ? notificationDetails.title : discoverytitle;
      notificationClassname = InHomeUtils.isNotEmpty(notificationDetails.notificationClassname) ? notificationDetails.notificationClassname : '';
      discoveryoverlayfun = InHomeUtils.isNotEmpty(notificationDetails.discoveryoverlayfun) ? notificationDetails.discoveryoverlayfun : discoveryoverlayfun;
      discoverySubtitle = InHomeUtils.isNotEmpty(notificationDetails.discoverySubtitle) ? notificationDetails.discoverySubtitle : discoverySubtitle;
      buttonData = InHomeUtils.isNotEmpty(notificationDetails.buttonData) ? notificationDetails.buttonData : buttonData;
      hideCloseButton = InHomeUtils.isNotEmpty(notificationDetails.hideCloseButton) ? notificationDetails.hideCloseButton : hideCloseButton;
    }

    return (

      // <div className="row spldiv accordion_blocks-content" data-reveal-content="zInternetOptions" style={{ transition: 'opacity 300ms' }} hidden="">
      //   <div className="accordionNotification" id={prodSectionID}>
      <div
      ref={(el) => {
        const isMobileViewStyle =
           (this.props?.buildProduct?.isECMNEnabled) && this.props?.isMobileView;
        if (isMobileViewStyle && el) {
          el.style.setProperty("margin-left", "0px", "important");
        }
      }}
      className= {(this.props?.buildProduct?.isECMNEnabled) ? "row spldiv accordion_blocks-content howManyTVs" : "row spldiv accordion_blocks-content"}
      data-reveal-content="zInternetOptions"
      style={{  transition: "opacity 300ms" }}
      hidden=""
    >
      <div
        className={(this.props?.buildProduct?.isECMNEnabled) ? " accordionNotification accordionNotificationRskn" : "accordionNotification"}
        id={prodSectionID}
      >

          {(discoverytitle) && (
            <Notification type={notificationType}
              title={discoverytitle}
              onClick={discoveryoverlayfun}
              className={notificationClassname}
              subtitle={discoverySubtitle}
              hideCloseButton={hideCloseButton}
              buttonData={buttonData}
            />
          )}
          {discoveryCheck}
          <div className="columns tiny-padding-vert-zero tiny-padding-bottom-small small-padding-all-micro medium-padding-all-small relative accordionChild">
            {!mm3Qualified && ! (this.props?.buildProduct?.isECMNEnabled) && tileImg}
            {/* {seeDetails} */}
            {stadiaOfferVerbiage}
            {marvelOfferVerbiage}
            {nydmaOfferVerbiage}
            {channelMsg}
            {unsupportMsg}
            {headingMsg}
            {emergencySelfInstallMessage}
            {hboUnSupportMsg}
            {/* {serviceType === Service?.perks && (
              <div>
                <p className="saveOnEveryOne">
                  Save on every one. Just ${isEmployee ? 5 : 10}/mo each.
                </p>
              </div>
            )} */}
            <div className={divAccordiontileClassName}>
            { (this.props?.buildProduct?.isECMNEnabled) ?
              this.props?.isMobileView ?(
                serviceType === Service?.tv && lqState?.isFCPflow === true ? (
                  <React.Fragment>
                    {!this?.props?.buildProduct?.tv?.spanishTV ? <MnCarousel tileComponents={mobileTvAll}/> : <MnCarousel tileComponents={mobileSpanish}/>}
                  </React.Fragment>
                ) : (
                  <MnCarousel tileComponents={listItems} />
                )
              ) : (
                listItems
              ): listItems}
              {/* { (this.props?.buildProduct?.isECMNEnabled) && perks} */}
              {perks}
              {vasChildList}   
              {vroomNotification}
            </div>
            {/* <div className={divAccordiontileClassName}>
              {tvSublistItems}
            </div>
            <div className={divAccordiontileClassName}>
              {streamServlist}
            </div> */}
             {! (this.props?.buildProduct?.isECMNEnabled) && (
              <>
                <div className={divAccordiontileClassName}>
                  {tvSublistItems}
                </div>
                <div className={divAccordiontileClassName}>
                  {streamServlist}
                </div>
              </>
            )}
            {(this.props?.buildProduct?.isECMNEnabled) && tvSublistItems !== "" && (
              <div className={divAccordiontileClassName}>
                {/* {this.props.toggleTVMoreOption &&
                !this?.props?.buildProduct?.tv?.spanishTV
                  ? streamServlist
                  : ""} */}
                {this.props.toggleTVMoreOption && !this?.props?.buildProduct?.tv?.spanishTV
                  ? tvSublistItems
                  : ""}
              </div>
            )}
            {fcphelperMsg}
            {moreOptLink}
            {helperMsg}
          </div>
        </div>
      </div>
    );
  }

};

export default withMobileView(productContainer);
